import gt, { memo as Se, useState as H, useCallback as V, useContext as X, useReducer as Ze, useEffect as W, useMemo as M, createElement as qt, createContext as Xt } from "react";
import { Grid as x, Block as ye, Input as Ae, Select as je, Button as z, Icon as L, Spinner as G, useNotifications as ve, AnalysisIcon as ke, Typography as xe, Checkbox as Kt, Autocomplete as Jt, Paper as Ct, Box as he, useTheme as Zt, Divider as et, NewTable as Tt, Tooltip as ft, FilterPanel as es, IconButton as ts, Modal as He, ContentBlock as ss } from "@prometheus/components";
import { FormElement as J, FormActionsContainer as tt, SubModuleDescriptionBlock as ns, ICON_COLUMN as as, ID_COLUMN as is, NAME_COLUMN as rs, CREATED_COLUMN as os, UPDATED_COLUMN as ls, AUTHOR_COLUMN as cs, SpinnerWidgetContainer as ge, CodeEditor as bt, FileContentType as us, PageList as ds, ImportMultipleSource as ps, TabWithCounter as Be, FloatingBlock as ms, DataSourceLogo as xs, DataSourceLabel as ys, AnalysisSubmissionStatusBadge as It, SecondaryContentWrapper as Ye, ConfirmationDialog as Ve, BaseInfoWrapper as Rt, AnalysisResultsBaseInfo as jt, TabsNavigationNew as At, ErrorBoundary as vt, ErrorPage as Qe, FileExplorer as _t, SpinnerContainer as hs, NestedInfoWrapper as Es, AnalysisBaseInfo as Ss, Versions as gs, ExportMultipleSource as Cs } from "@prometheus/features";
import { ModalContext as _e, useDownloadAnalysisTypes as Nt, useAnalysisImport as Ts, DialogContext as Ot, useInterval as fs, useExport as bs, useDesign as Is } from "@prometheus/hooks";
import { Status as E, EntityActions as Rs } from "@prometheus/types";
import { useNavigate as ce, Outlet as js, useParams as st, Routes as Ee, Route as B, matchPath as ct } from "react-router-dom";
import { api as A, getSortDirection as Fe, isEmpty as Z, createCrudMethodsListConfig as As, createSortingMethodListConfig as vs, createFiltersPanelListConfig as _s, generateAlias as Ns, getReducerWithProduce as nt, getCodeLanguageByFileExtension as Pt, getUUID as Os, createBreadcrumbsEntityConfig as Ps, parseFiltersToStringParams as Ls, formatFilterListNoFiql as Ds, getExecutionDuration as ws, getFileExtension as Us, getFileIconName as ks, formatBytes as Fs, getFormatDateAndTime as Le, getFullNameUser as Ms } from "@prometheus/utils";
import { AnalysisTypes as C, TypesOfContainer as Q, containerTypes as zs, IntervalValue as $s, FileExtension as De, ImportAtlasAsset as Oe, AnalysisSubmissionStatus as N, DateEdge as ut, EntityTypes as Gs } from "@prometheus/enums";
import { parseSimpleCountFormatResult as Bs, parseSimpleCountDesign as Ws, getSimpleCohortTemplate as Hs, simpleCountTemplateList as Ys, SimpleCountResults as Vs, SimpleCount as Qs, parseSimpleCountCharacterizationFormatResult as qs, parseSimpleCountCharacterizationDesign as Xs, getSimpleCohortCharacterizationTemplate as Ks, simpleCountCharacterizationTemplateList as Js, SimpleCountWithCharacterizationResults as Zs, SimpleCountWithCharacterization as en, parseBulkCohortCountsFormatResults as tn, parseBulkCohortCountsDesign as sn, getBulkCohortCountsTemplate as nn, bulkCohortCountsTemplateList as an, BulkCohortCountsResults as rn, BulkCohortCounts as on, parseIncidenceFormatResult as ln, parseIncidenceDesign as cn, getIncidenceTemplate as un, incidenceRateTemplateList as dn, IncidenceResults as pn, Incidence as mn, parseCharacterizationFormatResult as xn, parseCharacterizationDesign as yn, getCharacterizationTemplate as hn, characterizationTemplateList as En, CharacterizationResults as Sn, Characterization as gn, parsePathwayFormatResult as Cn, parsePathwayDesign as Tn, getPathwayTemplate as fn, pathwayTemplateList as bn, PathwayResults as In, Pathway as Rn, parseFeasibilityFormatResult as jn, parseFeasibilityDesign as An, getFeasibilityTemplate as vn, feasibilityTemplateList as _n, FeasibilityResults as Nn, Feasibility as On, parseEstimationDesign as Pn, getEstimationTemplate as Ln, estimationTemplateList as Dn, EstimationResults as wn, Estimation as Un, parsePredictionDesign as kn, getPredictionTemplate as Fn, PredictionResults as Mn, Prediction as zn, CustomResults as $n, Custom as Gn, StrategusResults as Bn, Strategus as Wn, parseDataCutFormatResult as Hn, parseDataCutDesign as Yn, cohortBasedDataCutTemplateList as Vn, CohortBasedDataCutResults as Qn, CohortBasedDataCut as qn, templateListTimeToEvent as Xn, TimeToEventResult as Kn, TimeToEvent as Jn, templateCostUtilization as Zn, CostUtilizationResults as ea, CostUtilization as ta } from "@prometheus/plugins";
import { useSelector as Lt, useDispatch as Me } from "react-redux";
import { getSummary as sa, setBreadcrumbs as at } from "@prometheus/redux";
import O from "@emotion/styled";
var qe = { exports: {} }, Ie = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dt;
function na() {
  if (dt) return Ie;
  dt = 1;
  var n = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function s(o, l, c) {
    var u = null;
    if (c !== void 0 && (u = "" + c), l.key !== void 0 && (u = "" + l.key), "key" in l) {
      c = {};
      for (var y in l)
        y !== "key" && (c[y] = l[y]);
    } else c = l;
    return l = c.ref, {
      $$typeof: n,
      type: o,
      key: u,
      ref: l !== void 0 ? l : null,
      props: c
    };
  }
  return Ie.Fragment = t, Ie.jsx = s, Ie.jsxs = s, Ie;
}
var Re = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var pt;
function aa() {
  return pt || (pt = 1, process.env.NODE_ENV !== "production" && function() {
    function n(i) {
      if (i == null) return null;
      if (typeof i == "function")
        return i.$$typeof === ee ? null : i.displayName || i.name || null;
      if (typeof i == "string") return i;
      switch (i) {
        case b:
          return "Fragment";
        case S:
          return "Profiler";
        case f:
          return "StrictMode";
        case $:
          return "Suspense";
        case se:
          return "SuspenseList";
        case k:
          return "Activity";
      }
      if (typeof i == "object")
        switch (typeof i.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), i.$$typeof) {
          case T:
            return "Portal";
          case j:
            return (i.displayName || "Context") + ".Provider";
          case R:
            return (i._context.displayName || "Context") + ".Consumer";
          case D:
            var g = i.render;
            return i = i.displayName, i || (i = g.displayName || g.name || "", i = i !== "" ? "ForwardRef(" + i + ")" : "ForwardRef"), i;
          case I:
            return g = i.displayName || null, g !== null ? g : n(i.type) || "Memo";
          case P:
            g = i._payload, i = i._init;
            try {
              return n(i(g));
            } catch {
            }
        }
      return null;
    }
    function t(i) {
      return "" + i;
    }
    function s(i) {
      try {
        t(i);
        var g = !1;
      } catch {
        g = !0;
      }
      if (g) {
        g = console;
        var v = g.error, w = typeof Symbol == "function" && Symbol.toStringTag && i[Symbol.toStringTag] || i.constructor.name || "Object";
        return v.call(
          g,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          w
        ), t(i);
      }
    }
    function o(i) {
      if (i === b) return "<>";
      if (typeof i == "object" && i !== null && i.$$typeof === P)
        return "<...>";
      try {
        var g = n(i);
        return g ? "<" + g + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function l() {
      var i = ne.A;
      return i === null ? null : i.getOwner();
    }
    function c() {
      return Error("react-stack-top-frame");
    }
    function u(i) {
      if (ae.call(i, "key")) {
        var g = Object.getOwnPropertyDescriptor(i, "key").get;
        if (g && g.isReactWarning) return !1;
      }
      return i.key !== void 0;
    }
    function y(i, g) {
      function v() {
        re || (re = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          g
        ));
      }
      v.isReactWarning = !0, Object.defineProperty(i, "key", {
        get: v,
        configurable: !0
      });
    }
    function m() {
      var i = n(this.type);
      return le[i] || (le[i] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), i = this.props.ref, i !== void 0 ? i : null;
    }
    function r(i, g, v, w, K, q, fe, pe) {
      return v = q.ref, i = {
        $$typeof: p,
        type: i,
        key: g,
        props: q,
        _owner: K
      }, (v !== void 0 ? v : null) !== null ? Object.defineProperty(i, "ref", {
        enumerable: !1,
        get: m
      }) : Object.defineProperty(i, "ref", { enumerable: !1, value: null }), i._store = {}, Object.defineProperty(i._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(i, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(i, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: fe
      }), Object.defineProperty(i, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: pe
      }), Object.freeze && (Object.freeze(i.props), Object.freeze(i)), i;
    }
    function d(i, g, v, w, K, q, fe, pe) {
      var U = g.children;
      if (U !== void 0)
        if (w)
          if (ue(U)) {
            for (w = 0; w < U.length; w++)
              a(U[w]);
            Object.freeze && Object.freeze(U);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else a(U);
      if (ae.call(g, "key")) {
        U = n(i);
        var te = Object.keys(g).filter(function(ze) {
          return ze !== "key";
        });
        w = 0 < te.length ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}", Te[U + w] || (te = 0 < te.length ? "{" + te.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          w,
          U,
          te,
          U
        ), Te[U + w] = !0);
      }
      if (U = null, v !== void 0 && (s(v), U = "" + v), u(g) && (s(g.key), U = "" + g.key), "key" in g) {
        v = {};
        for (var ie in g)
          ie !== "key" && (v[ie] = g[ie]);
      } else v = g;
      return U && y(
        v,
        typeof i == "function" ? i.displayName || i.name || "Unknown" : i
      ), r(
        i,
        U,
        q,
        K,
        l(),
        v,
        fe,
        pe
      );
    }
    function a(i) {
      typeof i == "object" && i !== null && i.$$typeof === p && i._store && (i._store.validated = 1);
    }
    var h = gt, p = Symbol.for("react.transitional.element"), T = Symbol.for("react.portal"), b = Symbol.for("react.fragment"), f = Symbol.for("react.strict_mode"), S = Symbol.for("react.profiler"), R = Symbol.for("react.consumer"), j = Symbol.for("react.context"), D = Symbol.for("react.forward_ref"), $ = Symbol.for("react.suspense"), se = Symbol.for("react.suspense_list"), I = Symbol.for("react.memo"), P = Symbol.for("react.lazy"), k = Symbol.for("react.activity"), ee = Symbol.for("react.client.reference"), ne = h.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ae = Object.prototype.hasOwnProperty, ue = Array.isArray, oe = console.createTask ? console.createTask : function() {
      return null;
    };
    h = {
      react_stack_bottom_frame: function(i) {
        return i();
      }
    };
    var re, le = {}, _ = h.react_stack_bottom_frame.bind(
      h,
      c
    )(), de = oe(o(c)), Te = {};
    Re.Fragment = b, Re.jsx = function(i, g, v, w, K) {
      var q = 1e4 > ne.recentlyCreatedOwnerStacks++;
      return d(
        i,
        g,
        v,
        !1,
        w,
        K,
        q ? Error("react-stack-top-frame") : _,
        q ? oe(o(i)) : de
      );
    }, Re.jsxs = function(i, g, v, w, K) {
      var q = 1e4 > ne.recentlyCreatedOwnerStacks++;
      return d(
        i,
        g,
        v,
        !0,
        w,
        K,
        q ? Error("react-stack-top-frame") : _,
        q ? oe(o(i)) : de
      );
    };
  }()), Re;
}
process.env.NODE_ENV === "production" ? qe.exports = na() : qe.exports = aa();
var e = qe.exports;
const ia = (n) => {
  const { pageNumber: t, pageSize: s, sortBy: o, query: l } = n, c = Fe(o), u = `/analyses/list?size=${s || ""}&page=${t || ""}&sort=${c}&${l || ""}`;
  return A.get(u);
}, ra = (n) => {
  const { pageNumber: t, pageSize: s, sortBy: o, query: l } = n, c = Fe(o), u = `/workspace/analyses/list?size=${s || ""}&page=${t || ""}&sort=${c}&${l || ""}`;
  return A.get(u);
}, oa = (n, t) => {
  const { pageNumber: s, pageSize: o, sortBy: l, query: c } = t, u = Fe(l), y = `/studies/${n}/analyses/list?size=${o || ""}&page=${s || ""}&sort=${u}&${c || ""}`;
  return A.get(y);
}, la = (n) => {
  const t = `/analyses/filter?${n}`;
  return A.get(t);
}, ca = (n) => {
  const t = `/workspace/analyses/filter?${n}`;
  return A.get(t);
}, ua = (n, t) => {
  const s = `/studies/${t}/analyses/filter?${n}`;
  return A.get(s);
}, we = (n) => A.get(`/analyses/${n}`), Dt = (n) => A.delete(`/analyses/${n}`), it = (n, t) => (t == null ? void 0 : t.type) === C.COST ? A.put(`/analysis/cost/${n}`, t) : A.put(`/analysis/${n}`, t), rt = (n) => A.post("/workspace/analyses", n), wt = (n, t) => A.post(`/workspace/analyses/copy/${n}`, t ? { name: t } : {}), Ut = (n, t) => A.post(`/studies/${n}/analyses`, t), kt = (n, t, s) => A.post(
  `/studies/${n}/analyses/copy/${t}`,
  s ? { name: s } : {}
), da = (n, t) => t !== "new" ? it(t, n) : rt(n), pa = (n, t, s) => t !== "new" ? it(t, n) : Ut(s, n), ma = () => A.get("/analyses/sorts"), xa = () => A.get("/workspace/analyses/sorts"), ya = (n, t) => {
  const { pageNumber: s, pageSize: o, sortBy: l, query: c } = t, u = Fe(l), y = `/analyses/${n}/batches/list?size=${o || 1e4}&page=${s || 0}&sort=${u}&${c || ""}`;
  return A.get(y).catch((m) => (console.error(m), []));
}, ha = (n) => {
  const t = `/analyses/batches/${n}`;
  return A.get(t);
}, Ea = (n) => {
  const t = `/submissions/${n}`;
  return A.get(t);
}, mt = (n) => {
  const t = `/submissions/${n}/results`;
  return A.get(t);
}, Sa = (n, t) => {
  const s = `/analyses/${n}/batches/filter?${t}`;
  return A.get(s);
}, ga = (n) => {
  const t = `/submissions/${n}/approve`;
  return A.post(t);
}, Ca = (n, t) => {
  const s = `/submissions/${n}/dismiss`;
  return A.post(s, t);
}, Ta = (n) => {
  const t = `/submissions/${n}/approve-publishing`;
  return A.post(t);
}, fa = (n, t) => {
  const s = `/submissions/${n}/dismiss-publishing`;
  return A.post(s, t);
}, ba = (n, t) => A.post(`/submissions/${n}/results/upload/zip`, t), Ia = (n) => A.get(`/submissions/${n}/history`), Ra = (n, t, s) => {
  const o = `/analyses/${n}/batches`;
  return A.post(o, { dataSourceIds: t, vaults: s });
}, ja = (n) => A.get(`/analyses/${n}/versions?size=10000`), Aa = (n) => A.get(`/analyses/version/${n}`), va = (n, t, s, o) => A.post(
  encodeURI(`/atlas/${n}/assets/${t}/export`),
  {},
  {
    params: {
      id: s,
      name: o
    },
    paramsSerializer: (l) => {
      let c = "";
      return Object.keys(l).forEach((u) => {
        c += `${u}=${encodeURIComponent(l[u])}&`;
      }), c.substring(0, c.length - 1);
    }
  }
), _a = (n) => A.get(`/analyses/${n}/summary`), Ft = Se(
  (n) => {
    var p;
    const { parentId: t, afterCreate: s, onCancel: o, createMethod: l, analysesTypes: c } = n, [u, y] = H(!1), [m, r] = H({
      title: "",
      type: (p = Object.keys(c)) == null ? void 0 : p[0],
      studyId: t
    }), [d, a] = H({
      useAgeGroups: !0,
      useGender: !0,
      useEthnicity: !1,
      useRace: !1
    }), h = V(() => {
      y(!0), l(
        m.type === C.SIMPLE_COUNTS_CHARACTERIZATION ? {
          ...m,
          ...d
        } : m
      ).then((T) => {
        y(!1), s == null || s(T);
      });
    }, [t, m, l]);
    return /* @__PURE__ */ e.jsx(x, { container: !0, p: 2, children: /* @__PURE__ */ e.jsx(ye, { children: /* @__PURE__ */ e.jsxs(x, { container: !0, spacing: 2, p: 2, children: [
      /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(J, { name: "title", textLabel: "Title", required: !0, children: /* @__PURE__ */ e.jsx(
        Ae,
        {
          id: "title",
          name: "title",
          type: "text",
          size: "medium",
          value: m.title,
          placeholder: "Enter title",
          onChange: (T) => r({ ...m, title: T.target.value }),
          fullWidth: !0
        }
      ) }) }),
      /* @__PURE__ */ e.jsx(x, { item: !0, xs: 6, children: /* @__PURE__ */ e.jsx(J, { name: "type", textLabel: "Type", required: !0, children: /* @__PURE__ */ e.jsx(
        je,
        {
          className: "",
          name: "type",
          disablePortal: !0,
          id: "type",
          options: Object.values(c).map((T) => ({
            name: T.title,
            value: T.type
          })),
          value: m.type,
          placeholder: "Select type",
          onChange: (T) => {
            r({ ...m, type: T });
          },
          fullWidth: !0
        }
      ) }) }),
      /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsxs(tt, { children: [
        /* @__PURE__ */ e.jsx(
          z,
          {
            variant: "outlined",
            disabled: u,
            onClick: o,
            startIcon: /* @__PURE__ */ e.jsx(L, { iconName: "deactivate" }),
            name: "cancel",
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ e.jsx(
          z,
          {
            disabled: u || Z(m.title) || Z(m.type),
            onClick: h,
            variant: "contained",
            color: "success",
            startIcon: u ? /* @__PURE__ */ e.jsx(G, { size: 16 }) : /* @__PURE__ */ e.jsx(L, { iconName: "submit" }),
            name: "save",
            children: "Save"
          }
        )
      ] }) })
    ] }) }) });
  }
), Na = (n) => {
  const t = ce(), { openModal: s, closeModal: o } = X(_e), { enqueueSnackbar: l } = ve(), c = (u) => {
    u.stopPropagation(), s(
      () => /* @__PURE__ */ e.jsx(
        Ft,
        {
          analysesTypes: n.analysesTypes,
          parentId: null,
          createMethod: rt,
          onCancel: o,
          afterCreate: (y) => {
            l({
              message: "Analysis created successfullly",
              variant: "success"
            }), t(`/workspace/analyses/${y.id}`), o();
          }
        }
      ),
      "Create analysis",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: o
      }
    );
  };
  return /* @__PURE__ */ e.jsx(
    ns,
    {
      title: "Analyses",
      description: "Analysis is a specific type of a data analytics question within a study. It can range from simple feasibility counts and characterization  to a more complex population level effect estimation and patient prediction.",
      iconName: "analyses",
      onCardClick: () => t("/workspace/analyses"),
      children: /* @__PURE__ */ e.jsx(x, { item: !0, width: 90, textAlign: "right", children: /* @__PURE__ */ e.jsx(
        z,
        {
          onClick: c,
          variant: "contained",
          color: "info",
          startIcon: /* @__PURE__ */ e.jsx(L, { iconName: "add" }),
          name: "save",
          children: "Create"
        }
      ) })
    }
  );
}, Xe = (n, t) => As(
  n,
  t,
  ia,
  Dt,
  oa,
  ra
), xt = (n, t) => _s(
  n,
  t,
  la,
  ua,
  ca
), Oa = (n) => vs(n, {
  getSorting: ma,
  getSortingWorkspace: xa
}), Ke = (n, t) => {
  switch (n) {
    case Q.WORKSPACE:
      return (s) => rt(s);
    case Q.STUDY:
      return (s) => Ut(t, s);
  }
}, yt = [
  as({ cell: ke }),
  is(),
  rs({ accessorKey: "title", id: "title" }),
  os(),
  ls(),
  cs()
], Pa = {
  form: {
    entityId: void 0,
    title: void 0,
    type: void 0,
    attribute: void 0,
    studyId: void 0,
    typeContainer: void 0,
    createNew: !1,
    analysis: void 0
  },
  analysisList: [],
  status: E.INITIAL
}, La = (n, t) => nt(n, (s) => {
  switch (t.type) {
    case "INIT":
      s.form = t.payload;
      break;
    case "UPDATE":
      s.form[t.payload.prop] = t.payload.value;
      break;
    case "FETCH_ANAKYSES":
      s.form.analysis = void 0, s.analysisList = [];
      break;
    case "FETCH_ANAKYSES_DONE":
      s.analysisList = t.payload;
      break;
    case "SAVE_PROGRESS":
      s.status = E.IN_PROGRESS;
      break;
    case "SAVE_DONE":
      s.status = E.SUCCESS, s.form.analysis = t.payload;
      break;
    case "SAVE_FAILED":
      s.status = E.ERROR;
      break;
  }
}), Da = (n, t) => {
  const [s, o] = Ze(La, Pa), l = (m) => {
    o({
      type: "INIT",
      payload: m
    });
  }, c = V(async () => {
    var r;
    if (!s.form.typeContainer || !s.form.type || !s.form.attribute || (s.form.createNew ? !s.form.title : !((r = s.form.analysis) != null && r.id)))
      return;
    o({
      type: "SAVE_PROGRESS"
      /* SAVE_PROGRESS */
    });
    const m = Ke(
      s.form.typeContainer,
      s.form.studyId
    );
    try {
      const d = s.form.createNew ? await m({
        title: s.form.title,
        type: s.form.type,
        studyId: s.form.studyId
      }) : await we(s.form.analysis.id), a = d.design || {}, h = s.form.type === C.CUSTOM ? {
        ...t,
        alias: Ns(t)
      } : t, p = await it(d.id, {
        ...d,
        design: {
          ...a,
          [s.form.attribute]: s.form.type === C.COHORT || s.form.type === C.SIMPLE_COUNTS_CHARACTERIZATION ? t.versionId : a != null && a[s.form.attribute] ? [...a == null ? void 0 : a[s.form.attribute], h] : [h]
        }
      });
      o({
        type: "SAVE_DONE",
        payload: p
      });
    } catch {
      o({
        type: "SAVE_FAILED"
        /* SAVE_FAILED */
      });
    }
  }, [s.form]), u = V(async () => {
    const m = Xe(
      s.form.typeContainer,
      s.form.studyId
    );
    o({
      type: "FETCH_ANAKYSES"
      /* FETCH_ANALYSES */
    });
    try {
      const r = await m.fetch(0, 1e5);
      o({
        type: "FETCH_ANAKYSES_DONE",
        payload: r.content.filter((d) => d.type === s.form.type)
      });
    } catch {
    }
  }, [s.form.typeContainer, s.form.studyId, s.form.type]), y = (m, r) => {
    o({
      type: "UPDATE",
      payload: {
        prop: m,
        value: r
      }
    });
  };
  return W(() => {
    l(n);
  }, []), W(() => {
    s.form.typeContainer && u();
  }, [s.form.typeContainer, s.form.studyId, s.form.type]), {
    ...s,
    updateForm: y,
    saveAnalysis: c
  };
}, We = (n = []) => {
  var t, s;
  return ((t = n.find((o) => {
    var u, y;
    const l = ((u = o.name) == null ? void 0 : u.toLowerCase()) || "", c = ((y = o.value) == null ? void 0 : y.toLowerCase()) || "";
    return l.includes("target") || c.includes("target");
  })) == null ? void 0 : t.value) || ((s = n[0]) == null ? void 0 : s.value);
}, wa = (n) => {
  var $, se;
  const {
    analysesTypes: t,
    onCancel: s,
    entity: o,
    analysisType: l,
    subModules: c,
    typeContainer: u,
    parentId: y
  } = n, m = ce(), { enqueueSnackbar: r } = ve(), d = l || (($ = Object.keys(t)) == null ? void 0 : $[0]), { form: a, analysisList: h, updateForm: p, saveAnalysis: T, status: b } = Da(
    {
      title: o.name,
      type: d,
      attribute: We(
        (se = t[d]) == null ? void 0 : se.templateList
      ),
      studyId: y,
      typeContainer: u,
      createNew: !0,
      analysis: void 0
    },
    o
  );
  W(() => {
    b === E.SUCCESS && (r({
      message: `Created anaysis ${a.analysis.title} with cohort ${o.name}`,
      variant: "success"
    }), m(
      a.typeContainer === Q.WORKSPACE ? `workspace/analyses/${a.analysis.id}` : `study-manager/${a.studyId}/analyses/${a.analysis.id}`
    ), s());
  }, [b]);
  const f = M(() => {
    var I;
    return ((I = t[a.type]) == null ? void 0 : I.templateList) || [];
  }, [t, a.type]), S = M(() => We(f), [f]);
  W(() => {
    if (!f.length) {
      Z(a.attribute) || p("attribute", void 0);
      return;
    }
    f.some(
      (P) => P.value === a.attribute
    ) || p("attribute", S);
  }, [f, a.attribute, S]);
  const R = () => {
    const I = !a.createNew;
    p("createNew", I), p("analysis", void 0), p("title", I ? o.name : void 0), S && p("attribute", S);
  }, j = b === E.IN_PROGRESS || (a.createNew ? Z(a.title) : Z(a.analysis)) || Z(a.typeContainer) || Z(a.type) || f.length > 0 && Z(a.attribute), D = a.type === C.CUSTOM ? "Referenced Cohorts" : "Template attribute";
  return a.type ? /* @__PURE__ */ e.jsx(x, { container: !0, p: 2, children: /* @__PURE__ */ e.jsx(ye, { children: /* @__PURE__ */ e.jsxs(x, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(xe, { variant: "h3", children: "Container:" }) }),
    /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(J, { name: "typeContainer", textLabel: "Add to", required: !0, children: /* @__PURE__ */ e.jsx(
      je,
      {
        className: "",
        name: "typeContainer",
        disablePortal: !0,
        id: "typeContainer",
        options: zs.filter((I) => I.value !== "ATLAS"),
        value: a.typeContainer,
        placeholder: "Select type",
        onChange: (I) => {
          p("typeContainer", I);
        },
        fullWidth: !0
      }
    ) }) }),
    a.typeContainer === Q.STUDY && /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(J, { name: "study", textLabel: "Study", required: !0, children: /* @__PURE__ */ e.jsx(
      c.study,
      {
        type: "component",
        name: "user-studies-list",
        subModules: c,
        config: {
          onChange: (I) => {
            I && p("studyId", I.id);
          },
          studyInitialId: y
        }
      }
    ) }) }),
    /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(xe, { variant: "h3", children: "Analysis:" }) }),
    /* @__PURE__ */ e.jsx(x, { item: !0, xs: 6, children: /* @__PURE__ */ e.jsx(J, { name: "type", textLabel: "Type", required: !0, children: /* @__PURE__ */ e.jsx(
      je,
      {
        className: "",
        name: "type",
        disablePortal: !0,
        id: "type",
        options: Object.keys(t).filter((I) => {
          var P, k;
          return ![
            C.STRATEGUS,
            C.ESTIMATION
          ].includes(I) && ((k = (P = t[I]) == null ? void 0 : P.templateList) == null ? void 0 : k.length) > 0;
        }).map((I) => ({
          name: t[I].title,
          value: t[I].type
        })),
        value: a.type,
        disabled: l != null,
        placeholder: "Select type",
        onChange: (I) => {
          var P;
          p("type", I), p(
            "attribute",
            We((P = t[I]) == null ? void 0 : P.templateList)
          );
        },
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ e.jsxs(x, { item: !0, xs: 12, children: [
      /* @__PURE__ */ e.jsx(
        Kt,
        {
          name: "createNew",
          onChange: R,
          checked: a.createNew
        }
      ),
      /* @__PURE__ */ e.jsx(xe, { sx: { marginLeft: "5px" }, variant: "caption", children: "Create new analysis" })
    ] }),
    a.createNew && /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(J, { name: "title", textLabel: "Title", required: !0, children: /* @__PURE__ */ e.jsx(
      Ae,
      {
        id: "title",
        name: "title",
        type: "text",
        size: "medium",
        value: a.title,
        placeholder: "Enter title",
        onChange: (I) => (
          // setState({ ...state, title: e.target.value })
          p("title", I.target.value)
        ),
        fullWidth: !0
      }
    ) }) }),
    !a.createNew && /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(J, { name: "analysis", textLabel: "Analysis", required: !0, children: /* @__PURE__ */ e.jsx(
      Jt,
      {
        className: "",
        name: "analysis",
        id: "analysis",
        options: h,
        value: a.analysis,
        placeholder: "Select analysis...",
        fullWidth: !0,
        isOptionEqualToValue: (I, P) => I.id === (P == null ? void 0 : P.id),
        onChange: (I, P) => {
          p("analysis", P);
        },
        getOptionLabel: (I) => I.title
      }
    ) }) }),
    f.length > 0 && /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      J,
      {
        name: "templateProp",
        textLabel: D,
        required: !0,
        children: /* @__PURE__ */ e.jsx(
          je,
          {
            className: "",
            name: "templateProp",
            disablePortal: !0,
            id: "templateProp",
            options: f,
            value: a.attribute,
            placeholder: "Select attribute",
            onChange: (I) => {
              p("attribute", I);
            },
            fullWidth: !0
          }
        )
      }
    ) }),
    /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsxs(tt, { children: [
      /* @__PURE__ */ e.jsx(
        z,
        {
          variant: "outlined",
          onClick: s,
          startIcon: /* @__PURE__ */ e.jsx(L, { iconName: "deactivate" }),
          name: "cancel",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ e.jsx(
        z,
        {
          disabled: j,
          onClick: T,
          variant: "contained",
          color: "success",
          startIcon: b === E.IN_PROGRESS ? /* @__PURE__ */ e.jsx(G, { size: 16 }) : /* @__PURE__ */ e.jsx(L, { iconName: "submit" }),
          name: "save",
          children: "Add"
        }
      )
    ] }) })
  ] }) }) }) : /* @__PURE__ */ e.jsx(e.Fragment, {});
}, Mt = [
  {
    component: Qs,
    results: Vs,
    templateList: Ys,
    getTemplate: Hs,
    url: "cohort",
    type: C.COHORT,
    title: "Cohort Counts",
    parseDesign: Ws,
    formatDesign: Bs,
    atlasEntity: null
  },
  {
    component: en,
    results: Zs,
    templateList: Js,
    getTemplate: Ks,
    url: "simple-counts-characterization",
    type: C.SIMPLE_COUNTS_CHARACTERIZATION,
    title: "Cohort Counts with Demographics",
    parseDesign: Xs,
    formatDesign: qs,
    atlasEntity: null
  },
  {
    component: on,
    results: rn,
    templateList: an,
    getTemplate: nn,
    url: "bulk-cohort-counts",
    type: C.BULK_COHORT_COUNTS,
    title: "Cohort Counts with Demographics (Multi)",
    parseDesign: sn,
    formatDesign: tn,
    atlasEntity: null
  },
  {
    component: mn,
    results: pn,
    templateList: dn,
    getTemplate: un,
    url: "incidence-rate",
    type: C.INCIDENCE,
    title: "Incidence Rates",
    parseDesign: cn,
    formatDesign: ln,
    atlasEntity: "IR",
    localConceptSet: !0,
    conceptSetAttr: "conceptSets"
  },
  {
    component: gn,
    results: Sn,
    templateList: En,
    getTemplate: hn,
    url: "cohort-characterization",
    type: C.COHORT_CHARACTERIZATION,
    title: "Cohort Characterization",
    parseDesign: yn,
    formatDesign: xn,
    atlasEntity: "CC",
    localConceptSet: !0,
    conceptSetAttr: "strataConceptSets"
  },
  {
    component: Rn,
    results: In,
    templateList: bn,
    getTemplate: fn,
    url: "pathway",
    type: C.COHORT_PATHWAY,
    title: "Cohort Pathway",
    parseDesign: Tn,
    formatDesign: Cn,
    atlasEntity: "PATHWAY"
  },
  {
    component: On,
    results: Nn,
    templateList: _n,
    getTemplate: vn,
    url: "feasibility",
    type: C.FEASIBILITY,
    title: "Feasibility",
    parseDesign: An,
    formatDesign: jn,
    atlasEntity: "FEASIBILITY"
  },
  {
    component: Un,
    results: wn,
    templateList: Dn,
    getTemplate: Ln,
    url: "estimation",
    type: C.ESTIMATION,
    title: "Population Level Estimation",
    parseDesign: Pn,
    atlasEntity: "PLE"
  },
  {
    component: zn,
    results: Mn,
    getTemplate: Fn,
    url: "prediction",
    type: C.PREDICTION,
    title: "Prediction",
    parseDesign: kn,
    atlasEntity: "PLP"
  },
  {
    component: Gn,
    results: $n,
    templateList: [
      {
        name: "Referenced Cohorts",
        value: "cohorts"
      }
    ],
    getTemplate: () => ({}),
    url: "custom",
    isUpload: !0,
    type: C.CUSTOM,
    title: "Custom",
    atlasEntity: null
  },
  {
    component: Wn,
    results: Bn,
    getTemplate: () => ({}),
    url: "strategus",
    isUpload: !0,
    type: C.STRATEGUS,
    title: "Strategus",
    atlasEntity: null
  },
  {
    component: qn,
    results: Qn,
    templateList: Vn,
    getTemplate: () => {
    },
    url: "datacut",
    type: C.DATACUT,
    title: "Cohort Export",
    parseDesign: Yn,
    formatDesign: Hn,
    atlasEntity: null
  },
  {
    component: Jn,
    results: Kn,
    templateList: Xn,
    getTemplate: () => ({
      targetCohorts: [],
      eventCohorts: [],
      minDaysToEvent: 1,
      restrictedMeanFollowUp: null,
      outcomeWashout: null,
      summaryReportTimesUnit: "days"
    }),
    url: "time-to-event",
    type: C.TIME_TO_EVENT,
    title: "Time to Event",
    parseDesign: (n, t) => ({
      ...t,
      type: n.type
    }),
    // formatDesign: d => d,
    atlasEntity: null
  },
  {
    component: ta,
    results: ea,
    templateList: Zn,
    getTemplate: () => ({
      targetCohorts: [],
      visitConceptIds: [],
      costMeasures: ["total_cost"],
      excludeZeroCostPatients: !1,
      visitLength: {
        Op: $s.GREATER_THAN,
        Value: null,
        Extent: null
      },
      dateRangeStart: null,
      dateRangeEnd: null,
      window: {
        startWith: "start",
        startOffset: 0,
        endWith: "start",
        endOffset: 365
      }
    }),
    url: "cost",
    type: C.COST,
    title: "Cost Utilization",
    parseDesign: (n, t) => ({
      ...t,
      type: n.type
    }),
    // formatDesign: d => d,
    atlasEntity: null
  }
], Ua = Se((n) => {
  const { name: t } = n, s = Lt((c) => c.user), { analyses: o, status: l } = Nt({
    preloadAnalysisTypes: n.config.analysisTypes,
    analyses: Mt,
    tenantId: s.data.activeTenant
  });
  return [E.INITIAL, E.IN_PROGRESS].includes(l) ? /* @__PURE__ */ e.jsx(ge, { children: /* @__PURE__ */ e.jsx(G, { size: 32 }) }) : /* @__PURE__ */ e.jsxs(gt.Fragment, { children: [
    t === "home-widget-analysis" && /* @__PURE__ */ e.jsx(Na, { ...n, analysesTypes: o }),
    t === "create-analysis-from-cohort" && /* @__PURE__ */ e.jsx(
      wa,
      {
        ...n.config,
        subModules: n.subModules,
        analysesTypes: o
      }
    )
  ] });
}), ka = Se(
  (n) => {
    var f;
    const { onCancel: t, typeContainer: s, parentId: o, onChange: l, analysesTypes: c } = n, [u, y] = H({
      title: void 0,
      type: (f = Object.keys(c)) == null ? void 0 : f[0],
      design: "",
      cohortName: void 0
    }), { enqueueSnackbar: m } = ve(), { createNewAnalysis: r, status: d, entity: a } = Ts(), h = M(
      () => Pt(De.JSON),
      []
    ), p = (S) => {
      const R = typeof S == "string" ? { design: S } : { [S.target.name]: S.target.value };
      y((j) => ({ ...j, ...R }));
    }, T = async (S) => {
      S.preventDefault(), await r(
        u,
        s,
        o,
        c[u.type]
      );
    };
    W(() => {
      d === E.SUCCESS ? (m({
        message: "Analysis created successfully",
        variant: "success"
      }), l(a.id)) : d === E.ERROR && m({
        message: "Oops! Something went wrong",
        variant: "error"
      });
    }, [d, a]);
    const b = () => u.type === C.COHORT || u.type === C.SIMPLE_COUNTS_CHARACTERIZATION ? Z(u.title) || Z(u.cohortName) : !1;
    return /* @__PURE__ */ e.jsxs(x, { container: !0, spacing: 2, children: [
      /* @__PURE__ */ e.jsx(x, { item: !0, xs: 6, children: /* @__PURE__ */ e.jsx(J, { name: "type", textLabel: "Type", required: !0, children: /* @__PURE__ */ e.jsx(
        je,
        {
          className: "",
          name: "type",
          disablePortal: !0,
          id: "type",
          options: Object.keys(c).map((S) => ({
            name: c[S].title,
            value: c[S].type
          })).filter(
            (S) => S.value !== C.CUSTOM && S.value !== C.STRATEGUS
          ),
          value: u.type,
          placeholder: "Select type",
          onChange: (S) => {
            y({ ...u, type: S });
          },
          fullWidth: !0
        }
      ) }) }),
      (u.type === C.COHORT || u.type === C.SIMPLE_COUNTS_CHARACTERIZATION) && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(x, { item: !0, xs: 6, children: /* @__PURE__ */ e.jsx(J, { name: "title", textLabel: "Title", required: !0, children: /* @__PURE__ */ e.jsx(
          Ae,
          {
            id: "title",
            name: "title",
            type: "text",
            size: "medium",
            value: u.title,
            placeholder: "Enter title",
            onChange: (S) => y({ ...u, title: S.target.value }),
            fullWidth: !0
          }
        ) }) }),
        /* @__PURE__ */ e.jsx(x, { item: !0, xs: 6, children: /* @__PURE__ */ e.jsx(J, { name: "cohortName", textLabel: "Cohort name", required: !0, children: /* @__PURE__ */ e.jsx(
          Ae,
          {
            id: "cohortName",
            name: "cohortName",
            type: "text",
            size: "medium",
            value: u.cohortName,
            placeholder: "Enter cohort name",
            onChange: (S) => y({ ...u, cohortName: S.target.value }),
            fullWidth: !0
          }
        ) }) })
      ] }),
      /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        bt,
        {
          title: "",
          data: u.design,
          fileName: u.design || "File",
          language: h,
          onChange: p,
          fileExtension: De.JSON,
          contentType: us.APPLICATION_JSON
        }
      ) }),
      /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsxs(tt, { children: [
        /* @__PURE__ */ e.jsx(
          z,
          {
            variant: "outlined",
            onClick: t,
            disabled: d === E.IN_PROGRESS,
            size: "small",
            startIcon: /* @__PURE__ */ e.jsx(L, { iconName: "deactivate" }),
            name: "cancel",
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ e.jsx(
          z,
          {
            disabled: d === E.IN_PROGRESS || !u.design || b() || Z(u.type),
            onClick: T,
            variant: "contained",
            size: "small",
            color: "success",
            startIcon: d === E.IN_PROGRESS ? /* @__PURE__ */ e.jsx(G, { size: 16 }) : /* @__PURE__ */ e.jsx(L, { iconName: "submit" }),
            name: "save",
            children: "Import"
          }
        )
      ] }) })
    ] });
  }
);
var zt = /* @__PURE__ */ ((n) => (n.CC = "COHORT_CHARACTERIZATION", n.PATHWAY = "PATHWAY", n.IR = "INCIDENCE_RATE", n.PLE = "ESTIMATION", n.FEASIBILITY = "FEASIBILITY", n))(zt || {});
const Fa = ({ viewMode: n }) => {
  const t = ce(), s = Me(), { enqueueSnackbar: o } = ve(), { openModal: l, closeModal: c } = X(_e), u = X(Ce), [y, m] = H(), r = M(() => u == null ? void 0 : u.config, []), d = r.typeContainer === Q.STUDY ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    "The available analyses for this study are limited to",
    " ",
    /* @__PURE__ */ e.jsx("b", { children: Object.values(u.analysesTypes).map((S) => S.title).join(", ") }),
    ". Other analyses may be disabled due to the current study configuration."
  ] }) : "", a = M(() => Ke(r.typeContainer, r.parentId), [r.typeContainer, r.parentId]), h = () => {
    s(sa(r.typeContainer, r.parentId));
  }, p = () => {
    l(
      () => /* @__PURE__ */ e.jsx(
        Ft,
        {
          analysesTypes: u.analysesTypes,
          parentId: r.parentId,
          createMethod: a,
          onCancel: c,
          afterCreate: (S) => {
            var R;
            o({
              message: "Analysis created successfully",
              variant: "success"
            }), t(S.id), c(), h(), (R = r == null ? void 0 : r.onReload) == null || R.call(r);
          }
        }
      ),
      "Add analysis",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: c
      }
    );
  }, T = (S) => {
    var R;
    return !((R = u.analysesTypes) != null && R[S.original.type]);
  }, b = M(() => [
    Oe.CC,
    Oe.PATHWAY,
    Oe.IR,
    Oe.PLE
  ].filter((S) => Object.keys(u.analysesTypes).includes(
    zt[S]
  )), []), f = () => {
    l(
      () => {
        var S;
        return /* @__PURE__ */ e.jsx(
          ps,
          {
            name: "analyses",
            currentContainer: r.typeContainer,
            parentId: r.parentId,
            onChange: async () => {
              m(Os()), c(), h();
            },
            createListMethods: Xe,
            cols: yt,
            createListFiltersMethod: xt,
            createMethodCreate: Ke,
            subModules: u.subModules,
            isSelect: !0,
            hideConflictResolutionMethod: !0,
            hideConflictResolutionControls: !0,
            successMessage: "Analysis successfully copied",
            atlasEntity: b,
            disableImportContainer: !0,
            analysesTypes: u.analysesTypes,
            manualImport: !0,
            disableRowSelect: T,
            disableAltasImport: (b == null ? void 0 : b.length) === 0,
            disableManualImport: ((S = Object.keys(u.analysesTypes).filter(
              (R) => R !== C.CUSTOM && R !== C.STRATEGUS
            )) == null ? void 0 : S.length) === 0,
            alertText: d,
            manualImportComponent: /* @__PURE__ */ e.jsx(
              ka,
              {
                analysesTypes: u.analysesTypes,
                typeContainer: r.typeContainer,
                onCancel: c,
                parentId: r.parentId,
                onChange: (R) => {
                  var j;
                  t(R), c(), h(), (j = r == null ? void 0 : r.onReload) == null || j.call(r);
                }
              }
            )
          }
        );
      },
      "Import analysis",
      {
        onClose: c,
        closeOnClickOutside: !0
      }
    );
  };
  return /* @__PURE__ */ e.jsx(
    ds,
    {
      reloadId: y,
      isImport: !0,
      onImport: f,
      onCreate: p,
      moduleConfig: u,
      viewMode: r.viewMode,
      listConfig: {
        rowId: "id",
        loadingMessage: "Loading analyses...",
        addButtonTitle: "Add analysis",
        moduleDescription: "Analyses are standard or custom data analytics modules - including characterizations, estimation and predictions, that can be used to perform observation research on data.",
        tableTitle: "Analyses",
        importButtonTitle: "Import",
        listInitialSort: { id: "modified.timestamp", desc: !0 },
        createCrudMethod: Xe,
        createFiltersPanel: xt,
        createSortingMethod: Oa,
        cols: yt
      },
      variant: "description",
      allowDelete: !0
    }
  );
}, Ma = "New Analysis", za = (n, t) => ({
  get: (s) => we(s),
  delete: (s) => Dt(s),
  update: (s, o) => {
    switch (n) {
      case Q.STUDY:
        return pa(s, o, t);
      case Q.WORKSPACE:
        return da(s, o);
    }
  },
  copy: (s, o) => {
    switch (n) {
      case Q.STUDY:
        return kt(t, s, o);
      case Q.WORKSPACE:
        return wt(s, o);
    }
  }
}), $a = (n, t, s, o) => {
  const l = [
    {
      title: "Design",
      value: "",
      end: !0
    }
  ];
  return n && (!s || s && (t == null ? void 0 : t.length) > 0) && l.push({
    title: /* @__PURE__ */ e.jsx(
      Be,
      {
        title: "Concept sets",
        count: (t == null ? void 0 : t.length) || 0,
        status: E.SUCCESS,
        dense: !0
      }
    ),
    value: "concept-sets"
  }), o.batches > 0 && l.push({
    title: /* @__PURE__ */ e.jsx(
      Be,
      {
        title: "Results",
        count: o.batches || 0,
        status: E.SUCCESS,
        dense: !0
      }
    ),
    value: "executions"
  }), l.push({
    align: "right",
    iconOnly: !0,
    iconName: "reload",
    title: /* @__PURE__ */ e.jsx(
      Be,
      {
        title: "Versions",
        count: o.versions || 0,
        status: E.SUCCESS,
        dense: !0
      }
    ),
    value: "versions"
  }), l;
}, Ga = {
  entityBreadcrumbs: (n, t, s) => Ps(Ma, n, t, s),
  apiMethodsVersioning: {
    getList: ja,
    getCurrent: Aa
  }
}, Ba = (n) => {
  const {
    type: t,
    typeContainer: s,
    parentId: o,
    analysisId: l,
    subModules: c,
    afterCreate: u,
    onClose: y
  } = n, { enqueueSnackbar: m } = ve(), [r, d] = H(E.INITIAL), [a, h] = H([]), [p, T] = H([]), b = async () => {
    d(E.IN_PROGRESS);
    try {
      await Ra(l, a, p), d(E.SUCCESS);
    } catch {
      d(E.ERROR);
    }
  };
  W(() => {
    r === E.SUCCESS && (m({
      message: "Analysis submitted",
      variant: "success"
    }), u()), r === E.ERROR && m({
      message: "Analysis was not submitted",
      variant: "error"
    });
  }, [r]);
  const f = M(() => r === E.IN_PROGRESS ? /* @__PURE__ */ e.jsx(G, { size: 18 }) : /* @__PURE__ */ e.jsx(L, { iconName: "submit" }), [r]);
  return /* @__PURE__ */ e.jsxs(
    x,
    {
      container: !0,
      px: 2,
      pt: 2,
      position: "relative",
      sx: { maxHeight: "calc(100vh - 116px)", overflowY: "auto" },
      children: [
        t === C.DATACUT ? /* @__PURE__ */ e.jsx(
          c.datasources,
          {
            type: "component",
            name: "data-source-list-with-vaults",
            subModules: c,
            config: {
              typeContainer: s,
              parentId: o,
              onAdd: (S, R) => {
                h(S), T(R);
              }
            }
          }
        ) : /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
          Ct,
          {
            elevation: 3,
            sx: { maxHeight: "calc(100vh - 150px)", overflowY: "auto" },
            children: /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
              c.datasources,
              {
                type: "component",
                name: "data-source-list-in-study",
                subModules: c,
                config: {
                  analysisId: l,
                  typeContainer: s,
                  parentId: o,
                  onAdd: h
                }
              }
            ) })
          }
        ) }),
        /* @__PURE__ */ e.jsx(ms, { item: !0, px: 2, py: 1, className: "visible", width: "700px", children: /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsxs(x, { item: !0, xs: 12, py: 2, textAlign: "right", children: [
          /* @__PURE__ */ e.jsx(
            z,
            {
              variant: "outlined",
              onClick: y,
              startIcon: /* @__PURE__ */ e.jsx(L, { iconName: "close" }),
              sx: { mr: 1 },
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ e.jsx(
            z,
            {
              disabled: !(a.length > 0) || r === E.IN_PROGRESS,
              onClick: b,
              variant: "contained",
              color: "success",
              startIcon: f,
              children: "Submit"
            }
          )
        ] }) }) })
      ]
    }
  );
}, Wa = (n, t, s, o) => (l, c) => {
  switch (n) {
    case Q.STUDY:
      return kt(t, l, c);
    case Q.WORKSPACE:
      return wt(l, c);
    case "ATLAS":
      return va(s, o, l, c);
  }
}, Ha = {
  executions: {
    data: [],
    pageCount: 0,
    totalElements: 0,
    numberOfElements: 0,
    pageNumber: 0,
    pageSize: 10
  },
  status: E.INITIAL,
  filters: { data: [], form: {} },
  progressExecutionIds: {}
}, Ya = (n, t) => nt(n, (s) => {
  switch (t.type) {
    case "GET_EXECUTION_REQUEST":
      s.status = s.status === E.INITIAL ? E.IN_PROGRESS : E.IN_PROGRESS_RELOAD;
      break;
    case "GET_EXECUTION_REQUEST_DONE":
      s.executions.data = t.payload.executions.content, s.executions.pageCount = t.payload.executions.totalPages, s.executions.totalElements = t.payload.executions.totalElements, s.executions.numberOfElements = t.payload.executions.numberOfElements, s.executions.pageNumber = t.payload.executions.number, s.filters.data = t.payload.filters, s.status = E.SUCCESS;
      break;
    case "APPROVE_EXECUTION_REQUEST":
    case "DISMISS_EXECUTION_REQUEST":
      s.progressExecutionIds = {
        ...s.progressExecutionIds,
        [t.payload]: !0
      };
      break;
    case "APPROVE_EXECUTION_REQUEST_DONE":
    case "DISMISS_EXECUTION_REQUEST_DONE":
    case "EXECUTION_REQUEST_FAILED":
      s.progressExecutionIds[t.payload] = !1;
      break;
    case "GET_EXECUTION_REQUEST_FAILED":
      s.status = E.ERROR;
      break;
    case "UPDATE_FILTERS":
      const { key: o, value: l } = t.payload;
      s.filters.form[o] = l;
      break;
  }
}), Va = (n) => {
  const [t, s] = Ze(Ya, Ha), o = (r, d) => {
    s({
      type: "UPDATE_FILTERS",
      payload: { key: r, value: d }
    });
  }, l = V(
    async (r = t.executions.pageNumber, d = t.executions.pageSize) => {
      s({
        type: "GET_EXECUTION_REQUEST"
        /* GET_EXECUTION_REQUEST */
      });
      try {
        const a = Ls(t.filters.form), h = await ya(n, {
          pageNumber: r,
          pageSize: d,
          // sortBy: sort,
          query: a
        }), p = await Sa(
          n,
          a
        ).then(Ds);
        s({
          type: "GET_EXECUTION_REQUEST_DONE",
          payload: { executions: h, filters: p }
        });
      } catch (a) {
        s({
          type: "GET_EXECUTION_REQUEST_FAILED",
          payload: a
        });
      }
    },
    [t.filters.form]
  ), c = V(
    async (r) => {
      s({
        type: "APPROVE_EXECUTION_REQUEST",
        payload: r
      });
      try {
        await ga(r), await l(), s({
          type: "APPROVE_EXECUTION_REQUEST_DONE",
          payload: r
        });
      } catch (d) {
        s({
          type: "EXECUTION_REQUEST_FAILED",
          payload: r
        }), console.error(d);
      }
    },
    [t.executions]
  ), u = V(
    async (r, d) => {
      s({
        type: "DISMISS_EXECUTION_REQUEST",
        payload: r
      });
      try {
        await Ca(r, d), await l(), s({
          type: "DISMISS_EXECUTION_REQUEST_DONE",
          payload: r
        });
      } catch (a) {
        s({
          type: "EXECUTION_REQUEST_FAILED",
          payload: r
        }), console.error(a);
      }
    },
    [t.executions]
  ), y = V(
    async (r, d) => {
      s({
        type: "APPROVE_EXECUTION_REQUEST",
        payload: r
      });
      try {
        await Ta(r, d), await l(), s({
          type: "APPROVE_EXECUTION_REQUEST_DONE",
          payload: r
        });
      } catch (a) {
        s({
          type: "EXECUTION_REQUEST_FAILED",
          payload: r
        }), console.error(a);
      }
    },
    [t.executions]
  ), m = V(
    async (r, d) => {
      s({
        type: "DISMISS_EXECUTION_REQUEST",
        payload: r
      });
      try {
        await fa(r, d), await l(), s({
          type: "APPROVE_EXECUTION_REQUEST_DONE",
          payload: r
        });
      } catch (a) {
        s({
          type: "EXECUTION_REQUEST_FAILED",
          payload: r
        }), console.error(a);
      }
    },
    [t.executions]
  );
  return {
    ...t,
    submissionApprove: c,
    submissionDismiss: u,
    submissionApprovePublish: y,
    submissionDismissPublish: m,
    getExecutions: l,
    updateFilters: o
  };
};
var Y = /* @__PURE__ */ ((n) => (n.GET_COMBINED_RESULTS = "GET_COMBINED_RESULTS", n.GET_COMBINED_RESULTS_DONE = "GET_COMBINED_RESULTS_DONE", n.GET_COMBINED_RESULTS_ERROR = "GET_COMBINED_RESULTS_ERROR", n.GET_RESULTS_REQUEST = "GET_RESULTS_REQUEST", n.GET_RESULTS_REQUEST_DONE = "GET_RESULTS_REQUEST_DONE", n.GET_RESULTS_REQUEST_FAILED = "GET_RESULTS_REQUEST_FAILED", n))(Y || {});
const Qa = {
  submission: null,
  execution: null,
  analysis: null,
  status: E.INITIAL,
  error: null
}, qa = (n, t) => nt(n, (s) => {
  switch (t.type) {
    case Y.GET_RESULTS_REQUEST:
    case Y.GET_COMBINED_RESULTS:
      s.status = E.IN_PROGRESS;
      break;
    case Y.GET_RESULTS_REQUEST_DONE:
      s.submission = t.payload.submission, s.analysis = t.payload.analysis, s.status = E.SUCCESS;
      break;
    case Y.GET_COMBINED_RESULTS_DONE:
      s.execution = t.payload.execution, s.analysis = t.payload.analysis, s.status = E.SUCCESS;
      break;
    case Y.GET_RESULTS_REQUEST_FAILED:
    case Y.GET_COMBINED_RESULTS_ERROR:
      s.error = t.payload, s.status = E.ERROR;
      break;
  }
}), Ue = [
  {
    value: N.PENDING,
    title: "Pending"
  },
  {
    value: N.QUEUED,
    title: "Queued"
  },
  {
    value: N.IN_PROGRESS,
    title: "In progress"
  },
  {
    value: N.FAILED,
    title: "Failed"
  },
  {
    value: N.INITIAL,
    title: "Initial"
  },
  {
    value: N.AWAITING_APPROVAL,
    title: "Awaiting approval"
  },
  {
    value: N.PROCESSING_RESULTS,
    title: "Processing in progress"
  },
  {
    value: N.PROCESSING_RESULTS_FAILED,
    title: "Processing failed"
  },
  {
    value: N.AWAITING_PUBLISHING_APPROVAL,
    title: "Awaiting publishing approval"
  },
  {
    value: N.PUBLISHED,
    title: "Published"
  },
  {
    value: N.DISMISSED,
    title: "Dismissed"
  }
];
ut.START_DATE, ut.END_DATE;
const Xa = (n) => {
  const { onOpen: t, viewMode: s } = n;
  return /* @__PURE__ */ e.jsx(
    z,
    {
      onClick: t,
      color: "primary",
      size: "small",
      variant: "contained",
      startIcon: /* @__PURE__ */ e.jsx(L, { iconName: "uploadFiles", name: "Execute" }),
      disabled: s,
      children: "Upload files"
    }
  );
};
O.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
`;
const Ka = O.div`
  cursor: pointer;
`;
O.div``;
O.div`
  padding: 12px;
`;
const Ja = O.div`
  font-size: 12px;
  display: flex;
  align-items: center;
  span {
    display: inline-block;
    margin-left: 8px;
    position: relative;
    /* top: -4px; */
  }
`;
O.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
`;
O.div`
  display: flex;
  flex-direction: column;
`;
O.div`
  padding: 8px 0;
  align-items: center;
  display: flex;
`;
O.div`
  color: ${({ theme: n }) => {
  var t;
  return (t = n.palette) == null ? void 0 : t.grey[500];
}};
  margin-right: 10px;
`;
O.div`
  //font-size: 16px;
  //text-transform: uppercase;
  font-weight: 500;
`;
O.div``;
O.div`
  border-top: 1px solid ${({ theme: n }) => {
  var t;
  return (t = n.palette) == null ? void 0 : t.borderColor.main;
}};
  width: 100%;
  margin: 16px 0;
`;
O.div`
  margin-bottom: 16px;
  //font-size: 16px;
  font-weight: bold;
`;
O.div`
  cursor: pointer;
  color: ${({ theme: n }) => {
  var t;
  return (t = n.palette) == null ? void 0 : t.primary.main;
}};
`;
const ht = O.div`
  display: flex;
  & > button:first-of-type {
    margin-right: -1px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  & > button:last-of-type {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`, Pe = O(z)`
  min-width: 0;
  padding: 6px;
  svg {
    font-size: 16px;
  }
  button {
    border-radius: 2px;
  }
`, Je = (n) => {
  if (typeof n != "string")
    return n;
  try {
    return JSON.parse(n);
  } catch {
    return null;
  }
}, Et = {
  minWidth: 0,
  padding: "3px 6px",
  whiteSpace: "nowrap",
  "& .MuiButton-startIcon": {
    marginLeft: 0,
    marginRight: "4px"
  }
}, Za = (n, t, s, o, l, c, u, y, m, r, d, a) => ({
  columns: [
    {
      header: "Data Source",
      accessorKey: "dataSource",
      size: 350,
      minSize: 150,
      enableResizing: !1,
      cell: ({ getValue: h }) => h() ? /* @__PURE__ */ e.jsxs(
        he,
        {
          sx: {
            display: "inline-flex",
            maxWidth: "100%",
            boxSizing: "border-box",
            "& *:first-child": {
              marginRight: 1
            },
            "& *:last-child": {
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              alignItems: "center"
              // marginRight: 1,
            }
          },
          children: [
            /* @__PURE__ */ e.jsx(xs, { value: h().id, size: 20 }),
            /* @__PURE__ */ e.jsx(ys, { dataSource: h() })
          ]
        }
      ) : /* @__PURE__ */ e.jsx(e.Fragment, {})
    },
    {
      header: "Status",
      accessorKey: "state",
      size: 130,
      enableResizing: !1,
      cell: ({ getValue: h, row: p }) => {
        const T = h(), { id: b, state: f } = p.original;
        return T ? /* @__PURE__ */ e.jsx(
          Ka,
          {
            onClick: () => {
              y(b);
            },
            children: /* @__PURE__ */ e.jsx(
              It,
              {
                status: Ue.find(
                  (S) => S.value === T
                )
              }
            )
          }
        ) : /* @__PURE__ */ e.jsx(e.Fragment, {});
      }
    },
    {
      header: "Duration",
      id: "duration",
      accessorFn: (h) => ws(h),
      size: 130,
      minSize: 130,
      enableResizing: !1
    },
    {
      header: "Execute",
      accessorKey: "state",
      id: "execute",
      size: 70,
      minSize: 70,
      enableResizing: !1,
      cell: ({ getValue: h, row: p }) => {
        const T = h(), b = p.original.actions, f = N.AWAITING_APPROVAL !== T || a[p.original.id], S = b.accept && !f, R = b.dismiss && !f, j = [
          N.PUBLISHED,
          N.IN_PROGRESS,
          N.AWAITING_PUBLISHING_APPROVAL
        ].includes(T), D = N.DISMISSED == T;
        return /* @__PURE__ */ e.jsxs(ht, { children: [
          /* @__PURE__ */ e.jsx(
            Pe,
            {
              disabled: !j && !S,
              onClick: () => o(p.original.id),
              color: "success",
              size: "small",
              variant: j ? "contained" : "outlined",
              sx: { pointerEvents: j ? "none" : "all" },
              children: a[p.original.id] ? /* @__PURE__ */ e.jsx(G, { size: 16 }) : /* @__PURE__ */ e.jsx(L, { iconName: "submit", name: "Execute" })
            }
          ),
          /* @__PURE__ */ e.jsx(
            Pe,
            {
              disabled: !D && !R,
              onClick: () => {
                m(l, p.original.id);
              },
              color: "error",
              size: "small",
              variant: D ? "contained" : "outlined",
              sx: { pointerEvents: D ? "none" : "all" },
              children: a[p.original.id] ? /* @__PURE__ */ e.jsx(G, { size: 16 }) : /* @__PURE__ */ e.jsx(L, { iconName: "deactivate", name: "Cancel" })
            }
          )
        ] });
      }
    },
    {
      header: "Publish",
      accessorKey: "state",
      id: "publish",
      size: 70,
      maxSize: 70,
      enableResizing: !1,
      cell: ({ getValue: h, row: p }) => {
        const T = h(), b = p.original.actions, f = N.AWAITING_PUBLISHING_APPROVAL !== T || a[p.original.id], S = b["approve-publish"] && !f, R = b.dismiss && !f, j = N.PUBLISHED === T, D = N.DISMISSED === T;
        return /* @__PURE__ */ e.jsxs(ht, { children: [
          /* @__PURE__ */ e.jsx(
            Pe,
            {
              disabled: !j && !S,
              onClick: () => c(p.original.id),
              color: "success",
              size: "small",
              sx: { pointerEvents: j ? "none" : "all" },
              variant: j ? "contained" : "outlined",
              children: a[p.original.id] ? /* @__PURE__ */ e.jsx(G, { size: 16 }) : /* @__PURE__ */ e.jsx(L, { iconName: "submit", name: "Execute" })
            }
          ),
          /* @__PURE__ */ e.jsx(
            Pe,
            {
              disabled: !D && !R,
              onClick: () => {
                m(u, p.original.id);
              },
              color: "error",
              size: "small",
              sx: { pointerEvents: D ? "none" : "all" },
              variant: D ? "contained" : "outlined",
              children: a[p.original.id] ? /* @__PURE__ */ e.jsx(G, { size: 16 }) : /* @__PURE__ */ e.jsx(L, { iconName: "deactivate", name: "Cancel" })
            }
          )
        ] });
      }
    },
    {
      header: "Results",
      accessorKey: "resultInfo",
      size: 92,
      minSize: 84,
      maxSize: 96,
      enableResizing: !1,
      cell: ({ getValue: h, row: p }) => {
        const T = h(), { id: b, state: f, resultFileAmount: S, dataSource: R, summary: j } = p.original, D = p.original.actions, $ = D["upload-results"];
        if (D["view-results"] || $) {
          if ([
            N.PROCESSING_RESULTS,
            N.IN_PROGRESS
          ].includes(f))
            return /* @__PURE__ */ e.jsx(e.Fragment, { children: R.executionPolicy === "MANUAL" ? /* @__PURE__ */ e.jsx(
              Xa,
              {
                viewMode: !$ && d,
                onOpen: () => s(b)
              }
            ) : /* @__PURE__ */ e.jsxs(Ja, { children: [
              /* @__PURE__ */ e.jsx(G, { size: 18 }),
              /* @__PURE__ */ e.jsxs("span", { children: [
                N.PROCESSING_RESULTS === f ? "Processing..." : "Executing...",
                " "
              ] })
            ] }) });
          if (f === N.FAILED || f === N.AWAITING_PUBLISHING_APPROVAL || f === N.PUBLISHED) {
            if (j)
              return /* @__PURE__ */ e.jsx(
                z,
                {
                  onClick: (P) => t(P, b),
                  variant: "contained",
                  size: "small",
                  color: "success",
                  startIcon: /* @__PURE__ */ e.jsx(L, { iconName: "search" }),
                  sx: Et,
                  name: "save",
                  children: j
                }
              );
            const I = Je(T);
            return /* @__PURE__ */ e.jsx(
              z,
              {
                onClick: (P) => t(P, b),
                variant: "contained",
                size: "small",
                color: "success",
                startIcon: /* @__PURE__ */ e.jsx(L, { iconName: "search" }),
                sx: Et,
                name: "save",
                children: I && T && r ? r(I) : `${S} files`
              }
            );
          }
        }
        return /* @__PURE__ */ e.jsx(e.Fragment, { children: "No files" });
      }
    }
  ]
}), $t = (n, t, s = null) => {
  const [o, l] = Ze(
    qa,
    Qa
  ), c = V(async () => {
    l({
      type: Y.GET_RESULTS_REQUEST
    });
    try {
      const y = await we(n), m = await Ea(t), r = await (m.resultInfo ?? mt(t));
      l({
        type: Y.GET_RESULTS_REQUEST_DONE,
        payload: {
          analysis: y,
          submission: {
            ...m,
            resultInfo: Je(r)
          }
        }
      });
    } catch (y) {
      l({
        type: Y.GET_RESULTS_REQUEST_FAILED,
        payload: y
      });
    }
  }, []), u = V(async () => {
    l({
      type: Y.GET_COMBINED_RESULTS
    });
    try {
      const y = await we(n), m = await ha(s), r = await Promise.all(
        m.submissions.map(
          (a) => mt(a.id)
        )
      ), d = m.submissions.map(
        (a, h) => ({
          ...a,
          resultInfo: Je(r[h])
        })
      );
      l({
        type: Y.GET_COMBINED_RESULTS_DONE,
        payload: {
          analysis: y,
          execution: {
            ...m,
            submissions: d
          }
        }
      });
    } catch (y) {
      console.error(y), l({
        type: Y.GET_COMBINED_RESULTS_ERROR,
        payload: y
      });
    }
  }, []);
  return W(() => {
    s && u(), t && c();
  }, []), {
    ...o
  };
};
O.div`
  padding: 10px;
  margin: 10px 0px;
  background: #ffffff;
`;
const ei = O.div`
  font-size: 14px;
  padding: 5px 5px;
  color: ${({ theme: n }) => {
  var t;
  return (t = n.palette) == null ? void 0 : t.primary.main;
}};
  font-weight: 700;
  border-bottom: 1px solid #e5e5e5;
  label {
    display: inline-block;
    position: relative;
    top: -6px;
    margin-left: 6px;
  }
  span {
    font-size: 10px;
    display: inline-block;
    position: relative;
    top: -6px;
    margin-left: 6px;
    color: #838383;
  }
  &:hover {
    background-color: ${({ theme: n }) => n.palette.backgroundColor.main};
  }
`;
O.div`
  margin: 15px;
  margin-top: 0;
`;
const ti = O.div`
  & > button {
    margin-right: 10px;
  }
`, si = (n) => {
  const { files: t, onClose: s, batchId: o } = n, l = Zt(), [c, u] = H(!1), [y, m] = H(""), r = () => {
    u(!0), m("");
    try {
      const a = `download-files-${o}`, h = document.createElement("iframe"), p = document.createElement("form");
      h.name = a, h.style.display = "none", p.action = `/api/analyses/batches/${o}/files/download`, p.method = "GET", p.target = a, p.style.display = "none", document.body.appendChild(h), document.body.appendChild(p), p.submit(), document.body.removeChild(p), window.setTimeout(() => {
        u(!1), s();
      }, 1500), window.setTimeout(() => {
        document.body.removeChild(h);
      }, 6e5);
    } catch (a) {
      console.error(a), m("Download failed. Please try again."), u(!1);
    }
  }, d = () => {
    c || s();
  };
  return /* @__PURE__ */ e.jsx(x, { container: !0, p: 2, children: /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsxs(Ct, { elevation: 0, sx: { p: 2 }, children: [
    t.map((a) => {
      var p, T;
      const h = Us(a.fileMetadata.realName);
      return /* @__PURE__ */ e.jsxs(ei, { children: [
        /* @__PURE__ */ e.jsx(
          L,
          {
            iconName: ks(h),
            sx: { color: (p = l.palette) == null ? void 0 : p.primary.main }
          }
        ),
        /* @__PURE__ */ e.jsx("label", { children: a.fileMetadata.realName }),
        /* @__PURE__ */ e.jsxs("span", { children: [
          "(",
          Fs(a.fileMetadata.length),
          ")"
        ] }),
        /* @__PURE__ */ e.jsx("span", { children: Le((T = a == null ? void 0 : a.modified) == null ? void 0 : T.timestamp) })
      ] });
    }),
    y && /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, mt: 2, children: /* @__PURE__ */ e.jsx(xe, { color: "error", variant: "subtitle2", children: y }) }),
    /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, mt: 2, children: /* @__PURE__ */ e.jsxs(ti, { children: [
      /* @__PURE__ */ e.jsx(
        z,
        {
          variant: "outlined",
          disabled: c,
          onClick: d,
          startIcon: /* @__PURE__ */ e.jsx(L, { iconName: "close" }),
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ e.jsx(
        z,
        {
          onClick: r,
          variant: "contained",
          color: "success",
          name: "download-executed",
          disabled: c,
          startIcon: c ? /* @__PURE__ */ e.jsx(G, { size: 16 }) : /* @__PURE__ */ e.jsx(L, { iconName: "submit" }),
          children: c ? "Starting download..." : "Download all files"
        }
      )
    ] }) })
  ] }) }) });
}, ni = O.div`
  font-size: 14px;
  font-weight: 700;
`, St = O.div`
  font-size: 12px;
  label {
    color: ${({ theme: n }) => {
  var t;
  return (t = n.palette) == null ? void 0 : t.primary.main;
}};
    font-weight: 700;
    font-size: 12px;
    margin-top: 10px;
  }
  span {
    font-weight: 500;
  }
`, ai = O.div`
  margin-top: 0px;
  font-size: 12px;
  label {
    color: ${({ theme: n }) => {
  var t;
  return (t = n.palette) == null ? void 0 : t.primary.main;
}};
    font-weight: 700;
    font-size: 12px;
    margin-top: 10px;
  }
  span {
    font-weight: 700;
  }
  button {
    // padding: 0 10px;
    // margin-top: -3px;
  }
`, ii = O.div`
  padding: 20px;
  background: #ffffff;
  border: 1px dotted ${({ theme: n }) => {
  var t;
  return (t = n.palette) == null ? void 0 : t.borderColor.main;
}};
  border-radius: 4px;
  box-sizing: border-box;
  max-width: 100%;
  overflow-x: hidden;
  margin-bottom: 8px;
`, ri = (n) => {
  var d;
  const { execution: t, columns: s, analysisType: o } = n, l = ce(), { openModal: c, closeModal: u } = X(_e), y = o === C.FEASIBILITY && t.submissions.some(
    (a) => a.state === N.AWAITING_PUBLISHING_APPROVAL || a.state === N.PUBLISHED
  ), m = () => {
    var a;
    c(
      () => /* @__PURE__ */ e.jsx(
        si,
        {
          files: t.executableFiles,
          batchId: t.id,
          analysisId: t.analysis.id,
          modified: t.modified,
          onClose: u,
          onChange: () => {
          }
        }
      ),
      /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        "Download Files",
        /* @__PURE__ */ e.jsx(xe, { variant: "subtitle2", component: "div", children: Le((a = t == null ? void 0 : t.modified) == null ? void 0 : a.timestamp) }),
        /* @__PURE__ */ e.jsx("div", {})
      ] }),
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: u
      }
    );
  }, r = () => {
    l("execution/" + t.id);
  };
  return /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, mb: 1, component: "tbody", children: /* @__PURE__ */ e.jsx("tr", { children: /* @__PURE__ */ e.jsx("td", { children: /* @__PURE__ */ e.jsxs(ii, { children: [
    /* @__PURE__ */ e.jsxs(
      x,
      {
        container: !0,
        justifyContent: "space-between",
        alignItems: "center",
        mb: 1,
        mt: -1,
        children: [
          /* @__PURE__ */ e.jsx(x, { item: !0, minWidth: 140, children: /* @__PURE__ */ e.jsx(ni, { children: `Execution #${parseInt(t.shortcut) + 1}` }) }),
          y && /* @__PURE__ */ e.jsx(x, { item: !0, children: /* @__PURE__ */ e.jsx(
            z,
            {
              variant: "contained",
              color: "success",
              onClick: r,
              size: "small",
              startIcon: /* @__PURE__ */ e.jsx(L, { iconName: "list", fontSize: "large" }),
              children: "Results summary"
            }
          ) })
        ]
      }
    ),
    /* @__PURE__ */ e.jsx(
      he,
      {
        sx: {
          width: "100%",
          maxWidth: "100%",
          overflowX: "auto",
          pb: 0.5,
          "& > .MuiBox-root": {
            minWidth: 890
          },
          "& .divTable": {
            minWidth: "100%"
          },
          '& [class*="table-cell-resultInfo"]': {
            paddingLeft: "3px",
            paddingRight: "3px"
          },
          '& [class*="table-cell-resultInfo"] .cell-wrapper': {
            display: "inline-flex",
            width: "fit-content",
            minWidth: "fit-content",
            maxWidth: "fit-content"
          }
        },
        children: /* @__PURE__ */ e.jsxs(he, { children: [
          /* @__PURE__ */ e.jsx(et, {}),
          /* @__PURE__ */ e.jsx(
            Tt,
            {
              data: t.submissions,
              columns: s,
              pageSize: (d = t.submissions) == null ? void 0 : d.length,
              hideSettings: !0,
              hidePagination: !0
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ e.jsxs(x, { container: !0, columnSpacing: 2, alignItems: "center", mt: 1, children: [
      /* @__PURE__ */ e.jsx(x, { item: !0, children: t.checksum && /* @__PURE__ */ e.jsxs(St, { children: [
        /* @__PURE__ */ e.jsx("label", { children: "Checksum: " }),
        /* @__PURE__ */ e.jsx(
          xe,
          {
            variant: "subtitle2",
            component: "span",
            sx: { color: "#0d1b40" },
            children: t.checksum.toString(16) || "-"
          }
        )
      ] }) }),
      /* @__PURE__ */ e.jsx(x, { item: !0, children: /* @__PURE__ */ e.jsxs(St, { children: [
        /* @__PURE__ */ e.jsx("label", { children: "Created at: " }),
        /* @__PURE__ */ e.jsx("span", { children: Le(t.created.timestamp) })
      ] }) }),
      /* @__PURE__ */ e.jsx(x, { item: !0, children: /* @__PURE__ */ e.jsxs(ai, { children: [
        /* @__PURE__ */ e.jsx("label", { children: "Submitted files:" }),
        /* @__PURE__ */ e.jsxs(
          z,
          {
            onClick: m,
            variant: "text",
            size: "small",
            startIcon: /* @__PURE__ */ e.jsx(L, { iconName: "import" }),
            sx: {
              textDecoration: "underline",
              fontSize: "12px",
              ml: 1
            },
            children: [
              t.executableFiles && t.executableFiles.length,
              " ",
              "files to download"
            ]
          }
        )
      ] }) })
    ] })
  ] }) }) }) });
}, oi = O.div`
  margin-top: 20px;
  & > button {
    margin-right: 10px;
  }
`, li = O.div`
  border-bottom: 1px solid
    ${({ theme: n }) => n.palette.borderColor.light};
  &:hover {
    background-color: ${({ theme: n }) => n.palette.backgroundColor.main};
  }
  span {
    display: block;
    font-size: 12px;
    text-align: right;
  }
  p {
    font-size: 12px;
    text-align: right;
    font-weight: 700;
    margin: 0;
    margin-top: 4px;
  }
`, ci = Se((n) => {
  const { onCancel: t, id: s } = n, [o, l] = H([]);
  return W(() => {
    Ia(s).then((c) => {
      l(c);
    });
  }, []), /* @__PURE__ */ e.jsx(ye, { children: /* @__PURE__ */ e.jsxs(x, { container: !0, p: 2, children: [
    o.map((c) => {
      var u, y;
      return /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(li, { children: /* @__PURE__ */ e.jsxs(x, { container: !0, p: 0.5, alignItems: "center", children: [
        /* @__PURE__ */ e.jsx(x, { item: !0, xs: 7, children: /* @__PURE__ */ e.jsxs(x, { container: !0, children: [
          /* @__PURE__ */ e.jsx(he, { component: "span", sx: { marginRight: "5px" }, children: /* @__PURE__ */ e.jsx(
            It,
            {
              status: Ue.find(
                (m) => m.value === c.data.state
              )
            }
          ) }),
          ((u = c == null ? void 0 : c.data) == null ? void 0 : u.dismissNote) && /* @__PURE__ */ e.jsx(
            ft,
            {
              text: ((y = c == null ? void 0 : c.data) == null ? void 0 : y.dismissNote) || "",
              color: "primary",
              width: 150,
              children: /* @__PURE__ */ e.jsx("span", { children: /* @__PURE__ */ e.jsx(
                L,
                {
                  iconName: "chatBubble",
                  sx: { color: "gray" }
                }
              ) })
            }
          )
        ] }) }),
        /* @__PURE__ */ e.jsxs(x, { item: !0, xs: 5, children: [
          /* @__PURE__ */ e.jsx("span", { children: Ms(c.user) }),
          /* @__PURE__ */ e.jsx("p", { children: Le(c.timestamp) })
        ] })
      ] }) }) });
    }),
    /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(oi, { children: /* @__PURE__ */ e.jsx(
      z,
      {
        variant: "outlined",
        onClick: t,
        size: "small",
        startIcon: /* @__PURE__ */ e.jsx(L, { iconName: "close" }),
        children: "Close"
      }
    ) }) })
  ] }) });
}), ui = (n) => {
  const {
    studyId: t,
    analysisId: s,
    path: o,
    updateRequest: l,
    rootPath: c,
    type: u,
    resultFormater: y,
    viewMode: m,
    executionCount: r
  } = n, d = ce(), { openModal: a, closeModal: h } = X(_e), { showDialog: p, hideDialog: T } = X(Ot), { subModules: b } = X(
    Ce
  ), {
    getExecutions: f,
    executions: {
      pageCount: S,
      pageSize: R,
      pageNumber: j,
      totalElements: D,
      data: $
    },
    filters: { data: se, form: I },
    progressExecutionIds: P,
    status: k,
    submissionApprove: ee,
    submissionDismiss: ne,
    submissionApprovePublish: ae,
    submissionDismissPublish: ue,
    updateFilters: oe
  } = Va(s);
  fs(() => {
    k !== E.INITIAL && k !== E.IN_PROGRESS && k !== E.IN_PROGRESS_RELOAD && f();
  }, 1e4), W(() => {
    r && f();
  }, [r]);
  const re = V(
    (g, v) => {
      g.preventDefault(), g.stopPropagation(), d(`submission/${v}`);
    },
    [d]
  ), le = (g) => {
    a(
      () => /* @__PURE__ */ e.jsx(ci, { id: g, onCancel: h }),
      "History",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: h
      }
    );
  }, _ = (g, v) => {
    p(Ve, {
      onSubmit: ({ dismissNote: w }) => {
        g(v, {
          note: w
        });
      },
      onClose: T,
      text: "Enter the reason for the refusal:",
      confirmButtonText: "REJECT",
      TextField: (w) => /* @__PURE__ */ e.jsx(he, { sx: { minWidth: "300px" }, children: /* @__PURE__ */ qt(Ae, { ...w, multiline: !0, key: v }) })
    });
  }, de = (g) => {
    a(
      () => /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ e.jsx(ye, { children: /* @__PURE__ */ e.jsx(
        b.documents,
        {
          type: "component",
          name: "upload-new-document",
          subModules: b,
          config: {
            onChange: () => {
              f(), h();
            },
            onClose: h,
            createMethod: (v) => ba(g, v),
            textAvailableExt: ".ZIP",
            acceptExt: [
              "application/zip",
              "application/octet-stream",
              "application/x-zip-compressed",
              "multipart/x-zip"
            ]
          }
        }
      ) }) }),
      "Upload files",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: h
      }
    );
  }, Te = M(
    () => Za(
      u,
      re,
      de,
      ee,
      ne,
      ae,
      ue,
      le,
      _,
      y,
      m,
      P
    ).columns,
    [
      re,
      ee,
      ne,
      ae,
      ue,
      P
    ]
  ), i = M(
    () => Object.values(I || {}).some(
      (g) => Array.isArray(g) ? g.some(Boolean) : !!g
    ),
    [I]
  );
  return W(() => {
    l && f();
  }, [l]), /* @__PURE__ */ e.jsxs(Ye, { children: [
    /* @__PURE__ */ e.jsx(ye, { outlined: !0, elevated: !0, children: /* @__PURE__ */ e.jsx(x, { container: !0, p: 2, children: /* @__PURE__ */ e.jsx(
      x,
      {
        item: !0,
        xs: 12,
        minHeight: 200,
        sx: {
          ".execustions-table > .thead": {
            display: "none"
          }
        },
        children: /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
          Tt,
          {
            data: $,
            variant: "controlled",
            columns: [{ header: "", accessorKey: "id" }],
            className: "execustions-table",
            customTableRow: ({ data: g }) => /* @__PURE__ */ e.jsx(
              ri,
              {
                execution: g,
                columns: Te,
                analysisType: u
              }
            ),
            pageCount: S,
            pageSize: R,
            pageIndex: j,
            totalElements: D,
            fetchData: f,
            loading: [E.INITIAL, E.IN_PROGRESS].includes(k),
            showFilterToggle: !0,
            hideTableOptions: !0,
            filtersDefaultClosed: !0,
            hasFilters: i,
            searchComponent: /* @__PURE__ */ e.jsx(x, { container: !0, justifyContent: "flex-end", children: /* @__PURE__ */ e.jsx(
              ts,
              {
                size: "small",
                onClick: () => {
                  f();
                },
                name: "reload",
                disabled: k === E.IN_PROGRESS_RELOAD,
                children: k === E.IN_PROGRESS_RELOAD ? /* @__PURE__ */ e.jsx(G, { size: 14 }) : /* @__PURE__ */ e.jsx(ft, { text: "Reload executions", children: /* @__PURE__ */ e.jsx(L, { iconName: "reload", sx: { fontSize: 16 } }) })
              }
            ) }),
            children: /* @__PURE__ */ e.jsx(
              es,
              {
                showLabel: !0,
                filters: se,
                value: I,
                onChange: oe,
                isLoading: k === E.IN_PROGRESS,
                isReloading: k === E.IN_PROGRESS_RELOAD,
                placeholderSize: 2
              }
            )
          }
        ) })
      }
    ) }) }),
    /* @__PURE__ */ e.jsx(js, {})
  ] });
}, di = O.div`
  text-align: center;
  font-size: 24px;
  margin-top: 50px;
  margin-bottom: 50px;
  color: lightgrey;
`, pi = Se((n) => {
  const { resultInfo: t, analysisInfo: s, analysesTypes: o, subModules: l } = n, { results: c } = M(
    () => o[s == null ? void 0 : s.type],
    [s == null ? void 0 : s.type]
  ), u = V(() => /* @__PURE__ */ e.jsx(
    c,
    {
      data: t,
      analysisInfo: s,
      subModules: l
    }
  ), [s == null ? void 0 : s.type]);
  if (![
    C.COHORT,
    C.INCIDENCE,
    C.COHORT_PATHWAY,
    C.COHORT_CHARACTERIZATION,
    C.SIMPLE_COUNTS_CHARACTERIZATION,
    C.BULK_COHORT_COUNTS,
    C.DATACUT,
    C.FEASIBILITY,
    C.TIME_TO_EVENT,
    C.COST
  ].includes(s == null ? void 0 : s.type))
    return /* @__PURE__ */ e.jsx(ge, { children: /* @__PURE__ */ e.jsx(di, { children: "View raw results in the Files tab" }) });
  const y = [
    C.INCIDENCE,
    C.FEASIBILITY,
    C.TIME_TO_EVENT,
    C.COST
  ].includes(s == null ? void 0 : s.type);
  return /* @__PURE__ */ e.jsx(x, { container: !0, children: /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: y ? /* @__PURE__ */ e.jsx(x, { container: !0, children: /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: u() }) }) : /* @__PURE__ */ e.jsx(ye, { elevated: !0, outlined: !0, children: /* @__PURE__ */ e.jsx(x, { container: !0, children: /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: u() }) }) }) }) });
}), Gt = (n, t, s) => {
  const o = [], {
    rootTitle: l,
    parentTitle: c,
    title: u,
    rootPath: y,
    parentId: m,
    path: r,
    currentId: d,
    currentTitle: a
  } = s;
  return l && (o[0] = {
    name: l,
    path: `${y}`
  }), m && (o[1] = {
    name: c,
    path: `${y}/${m}`
  }), l !== u ? m ? (o[2] = {
    name: u,
    path: r
  }, o[3] = {
    name: a,
    path: `${r}/${d}`
  }, o[4] = {
    name: t,
    path: `${r}/${n}`
  }) : (o[1] = {
    name: u,
    path: r
  }, o[2] = {
    name: a,
    path: `${r}/${d}`
  }, o[3] = {
    name: t,
    path: `${r}/${n}`
  }) : (o[2] = {
    name: a,
    path: `${r}/${d}`
  }, o[3] = {
    name: t,
    path: `${r}/${n}`
  }), o;
}, mi = (n) => n ? [
  {
    title: "Analysis results",
    value: "",
    end: !0
  },
  {
    title: "Files",
    value: "files"
  }
] : [
  {
    title: "Files",
    value: ""
  }
], Bt = () => {
  var j;
  const n = Me(), { id: t, submissionId: s } = st(), { rootSettings: o, path: l, title: c, config: u, analysesTypes: y, subModules: m } = X(
    Ce
  ), r = ce(), { submission: d, analysis: a, status: h } = $t(t, s), p = (d == null ? void 0 : d.resultInfo) != null, T = M(() => mi(p), [p]), { rootPath: b, rootTitle: f } = o, { parentId: S, parentTitle: R } = u;
  return W(() => {
    n(
      at(
        Gt(s, "Results", {
          path: l,
          title: c,
          rootPath: b,
          rootTitle: f,
          parentTitle: R,
          parentId: S,
          currentId: t,
          currentTitle: a == null ? void 0 : a.title
        })
      )
    );
  }, [l, a]), [E.INITIAL, E.IN_PROGRESS].includes(h) ? /* @__PURE__ */ e.jsx(ge, { children: /* @__PURE__ */ e.jsx(G, { size: 32 }) }) : /* @__PURE__ */ e.jsxs(x, { container: !0, children: [
    /* @__PURE__ */ e.jsxs(Rt, { children: [
      /* @__PURE__ */ e.jsx(
        jt,
        {
          entity: a,
          submission: {
            ...d,
            status: Ue.find(
              (D) => D.value === d.state
            )
          },
          AnalysisIcon: /* @__PURE__ */ e.jsx(ke, { value: a.type, size: 32 })
        }
      ),
      /* @__PURE__ */ e.jsx(et, {}),
      /* @__PURE__ */ e.jsx(At, { tabs: T, withRouting: !0, secondary: !0 })
    ] }),
    /* @__PURE__ */ e.jsxs(vt, { fallBack: /* @__PURE__ */ e.jsx(e.Fragment, { children: "Something went wrong" }), children: [
      /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, py: 2, px: 6, children: d.resultInfoError === "USER_HAS_NO_ACCESS_TO_SUBMISSION_RESULTS" ? /* @__PURE__ */ e.jsx(
        Qe,
        {
          statusText: "Permission denied. If the problem persists, please contact the data source owner.",
          status: 403,
          message: "Submission status: " + ((j = Ue.find(
            (D) => D.value === d.state
          )) == null ? void 0 : j.title),
          data: void 0,
          path: l + "/" + a.id + "/executions"
        }
      ) : /* @__PURE__ */ e.jsxs(Ee, { children: [
        p && /* @__PURE__ */ e.jsx(
          B,
          {
            path: "*",
            element: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              /* @__PURE__ */ e.jsx(
                pi,
                {
                  analysesTypes: y,
                  analysisInfo: a,
                  resultInfo: a.type === C.FEASIBILITY ? { submissions: [d] } : d.resultInfo,
                  subModules: m
                }
              ),
              /* @__PURE__ */ e.jsx(Ee, { children: /* @__PURE__ */ e.jsx(
                B,
                {
                  path: "modal/related/:conceptId",
                  element: /* @__PURE__ */ e.jsx(
                    He,
                    {
                      open: !0,
                      onClose: () => {
                        r("");
                      },
                      children: /* @__PURE__ */ e.jsx(
                        m.vocabulary,
                        {
                          type: "component",
                          name: "vocabulary-concept",
                          subModules: m,
                          config: {
                            onClose: () => {
                              r("");
                            },
                            viewMode: !0,
                            vocabularyMode: !1
                          },
                          canEdit: !1,
                          path: `${l}/${t}/submissions/${s}`
                        }
                      )
                    }
                  )
                }
              ) })
            ] })
          }
        ),
        /* @__PURE__ */ e.jsx(
          B,
          {
            path: p ? "files" : "",
            element: /* @__PURE__ */ e.jsx(
              _t,
              {
                submissionId: s,
                url: "submissions"
              }
            )
          }
        )
      ] }) }),
      " "
    ] })
  ] });
}, xi = Se((n) => {
  const { id: t } = n, { exportAnalysis: s } = bs(Gs.ANALYSIS, t), o = M(
    () => s == null ? void 0 : s.title,
    [s == null ? void 0 : s.title]
  ), l = M(
    () => Pt(De.JSON),
    []
  );
  return /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, p: 2, children: s && /* @__PURE__ */ e.jsx(
    bt,
    {
      data: s,
      fileName: o,
      language: l,
      readOnly: !0,
      fileExtension: De.JSON
    }
  ) });
}), yi = () => {
  const n = Me(), { id: t, executionId: s } = st(), { rootSettings: o, path: l, title: c, config: u, analysesTypes: y, subModules: m } = X(
    Ce
  ), { execution: r, analysis: d, status: a } = $t(t, null, s), { results: h } = M(
    () => y[d == null ? void 0 : d.type] || {},
    [d == null ? void 0 : d.type, y]
  ), p = V(() => {
    switch (a) {
      case E.SUCCESS:
        return /* @__PURE__ */ e.jsx(
          h,
          {
            data: r,
            analysisInfo: d,
            subModules: m
          }
        );
      case E.IN_PROGRESS:
      case E.INITIAL:
        return /* @__PURE__ */ e.jsx(he, { textAlign: "center", children: /* @__PURE__ */ e.jsx(G, {}) });
      case E.ERROR:
        return "";
    }
  }, [d == null ? void 0 : d.type]), { rootPath: T, rootTitle: b } = o, { parentId: f, parentTitle: S } = u;
  return W(() => {
    n(
      at(
        Gt(s, "Results", {
          path: l,
          title: c,
          rootPath: T,
          rootTitle: b,
          parentTitle: S,
          parentId: f,
          currentId: t,
          currentTitle: d == null ? void 0 : d.title
        })
      )
    );
  }, [l, d]), [E.INITIAL, E.IN_PROGRESS].includes(a) ? /* @__PURE__ */ e.jsx(ge, { children: /* @__PURE__ */ e.jsx(G, { size: 32 }) }) : /* @__PURE__ */ e.jsxs(x, { container: !0, children: [
    /* @__PURE__ */ e.jsx(Rt, { children: /* @__PURE__ */ e.jsx(
      jt,
      {
        entity: d,
        AnalysisIcon: /* @__PURE__ */ e.jsx(ke, { value: d.type, size: 32 })
      }
    ) }),
    /* @__PURE__ */ e.jsx(vt, { fallBack: /* @__PURE__ */ e.jsx(e.Fragment, { children: "Something went wrong" }), children: /* @__PURE__ */ e.jsxs(Ee, { children: [
      /* @__PURE__ */ e.jsx(
        B,
        {
          path: "*",
          element: /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, py: 2, px: 6, children: p() })
        }
      ),
      /* @__PURE__ */ e.jsx(
        B,
        {
          path: "files",
          element: /* @__PURE__ */ e.jsx(
            x,
            {
              container: !0,
              spacing: 2,
              px: 4,
              py: 2,
              sx: {
                ".collapsible-block__content-container": {
                  p: 0
                }
              },
              children: r.submissions.map((R) => /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
                ss,
                {
                  collapsible: !0,
                  title: R.dataSource.name,
                  outlined: !0,
                  defaultState: !1,
                  children: /* @__PURE__ */ e.jsx(
                    _t,
                    {
                      submissionId: R.id,
                      url: "submissions"
                    }
                  )
                }
              ) }))
            }
          )
        }
      )
    ] }) })
  ] });
}, hi = () => {
  var lt;
  const n = ce(), { id: t } = st(), s = Me(), { showDialog: o, hideDialog: l } = X(Ot), c = ct(
    "study-manager/:id/analyses/:id/submissions/:submissionId/*",
    location.pathname
  ), u = ct(
    "workspace/analyses/:id/submissions/:submissionId/*",
    location.pathname
  ), { openModal: y, closeModal: m } = X(_e), [r, d] = H(0), { rootSettings: a, path: h, title: p, config: T, subModules: b, analysesTypes: f } = X(Ce), { rootPath: S, rootTitle: R } = a, { parentId: j, parentTitle: D, typeContainer: $ } = T, { entityBreadcrumbs: se, apiMethodsVersioning: I } = Ga, P = M(() => za($, j), [j]), {
    status: k,
    summary: ee,
    component: ne,
    conceptSetAttr: ae,
    formatDesign: ue,
    atlasEntity: oe,
    designStatus: re,
    isVersionMode: le,
    entity: _,
    error: de,
    updateEntity: Te,
    design: i,
    updateDesign: g,
    isEqual: v,
    reloadDesign: w,
    setVersionEntity: K,
    revertEntity: q,
    deleteEntity: fe,
    copyEntity: pe,
    outdatedCohortReferences: U,
    saveDesign: te,
    getCountsSummary: ie,
    updateDesignBase: ze,
    permissions: $e,
    actions: Ne
  } = Is(P, t, "Analysis", f, _a), me = M(() => {
    switch ($) {
      case Q.WORKSPACE:
        return !1;
      case Q.STUDY:
        return !(Ne != null && Ne[Rs.UPDATE]);
      default:
        return !0;
    }
  }, [Ne, $]), ot = M(
    () => ({
      ...ee,
      batches: Math.max((ee == null ? void 0 : ee.batches) || 0, r)
    }),
    [r, ee]
  ), Wt = M(() => {
    var F, be;
    return $a(
      (F = f[_ == null ? void 0 : _.type]) == null ? void 0 : F.localConceptSet,
      (be = i == null ? void 0 : i.design) == null ? void 0 : be[ae],
      me,
      ot
    );
  }, [_, ot, i, me]), Ht = () => {
    o(Ve, {
      onSubmit: async () => {
        try {
          await fe(), n(`/${h}`);
        } catch {
        }
      },
      onClose: l,
      text: "Are you sure you want to delete this analysis?",
      confirmButtonText: "DELETE",
      variant: "error"
    });
  };
  W(() => {
    _ && !c && !u && s(
      at(
        se(t, _ == null ? void 0 : _.title, {
          path: h,
          title: p,
          rootPath: S,
          rootTitle: R,
          parentTitle: D,
          parentId: j
        })
      )
    );
  }, [h, _, c, u]), W(() => {
    document.title = "Prometheus - " + R + " - Analyses";
  }, [R]);
  const Ge = (F) => {
    const be = (U == null ? void 0 : U.length) || 0;
    be ? o(Ve, {
      onSubmit: F,
      onClose: l,
      text: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        "Newer versions exist for",
        /* @__PURE__ */ e.jsxs("b", { children: [
          " ",
          U.map((Qt) => Qt.name).join(", "),
          " "
        ] }),
        "cohort",
        be > 1 ? "s" : "",
        ", do you want to",
        " ",
        /* @__PURE__ */ e.jsx("b", { children: "continue without refreshing" }),
        " them?"
      ] }),
      cancelButtonText: "Return to Analysis",
      confirmButtonText: "Continue",
      variant: "info"
    }) : F();
  }, Yt = () => {
    y(
      () => /* @__PURE__ */ e.jsx(
        Ba,
        {
          subModules: b,
          typeContainer: $,
          parentId: j,
          analysisId: t,
          afterCreate: async () => {
            d((F) => F + 1), await ie(), m(), n("executions");
          },
          type: _.type,
          onClose: m
        }
      ),
      "Create submit request",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: m
      }
    );
  }, Vt = () => {
    y(
      () => /* @__PURE__ */ e.jsx(
        Cs,
        {
          id: _.id,
          name: i.title,
          parentId: j,
          currentContainer: $,
          subModules: b,
          createCopyMethod: Wa,
          entityAtlas: oe,
          typeEntity: "analyses",
          analysisType: i.type,
          onChange: () => {
            m();
          },
          exportJson: /* @__PURE__ */ e.jsx(xi, { id: _.id })
        }
      ),
      "Export analysis",
      {
        closeOnClickOutside: !0,
        onClose: m
      }
    );
  };
  return k === E.ERROR ? /* @__PURE__ */ e.jsx(ge, { children: /* @__PURE__ */ e.jsx(Qe, { ...de.response, path: h }) }) : k === E.INITIAL || k === E.IN_PROGRESS ? /* @__PURE__ */ e.jsx(hs, { children: /* @__PURE__ */ e.jsx(G, { size: 62 }) }) : /* @__PURE__ */ e.jsx(x, { container: !0, px: 6, flexGrow: 1, flexDirection: "column", children: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Es, { children: /* @__PURE__ */ e.jsx(
      Ss,
      {
        entity: le ? i : i || _,
        AnalysisIcon: /* @__PURE__ */ e.jsx(ke, { value: _ == null ? void 0 : _.type, size: 32 }),
        onDelete: Ht,
        onExport: () => Ge(Vt),
        onSubmit: (F) => {
          te({
            ...i,
            title: F.title,
            description: F.description
          }), ie();
        },
        onChange: (F) => {
          ze({
            title: F.title,
            description: F.description
          });
        },
        onAnalysisSubmit: () => Ge(Yt),
        disableSave: k !== E.SUCCESS && re !== E.SUCCESS || $e.disableSave,
        canExecute: $e.canExecute,
        executionMessages: $e.executionMessages,
        onSave: async () => {
          await Promise.allSettled([
            te(i),
            ie()
          ]);
        },
        onCopy: () => {
          Ge(async () => {
            const F = await pe(i);
            n(`/${h}/${F.id}`);
          }), ie();
        },
        versionPreview: le,
        onVersionRevert: q,
        onVersionSave: () => {
          te({
            ..._,
            design: i.design,
            title: i.originName
          }), ie();
        },
        viewMode: me
      }
    ) }),
    /* @__PURE__ */ e.jsx(e.Fragment, { children: re === E.SUCCESS && /* @__PURE__ */ e.jsxs(x, { container: !0, children: [
      /* @__PURE__ */ e.jsxs(x, { item: !0, xs: 12, children: [
        /* @__PURE__ */ e.jsx(At, { tabs: Wt, withRouting: !0, secondary: !0 }),
        /* @__PURE__ */ e.jsx(et, {})
      ] }),
      /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, py: 3, children: /* @__PURE__ */ e.jsxs(Ee, { children: [
        /* @__PURE__ */ e.jsx(
          B,
          {
            index: !0,
            element: /* @__PURE__ */ e.jsx(Ye, { children: ne ? /* @__PURE__ */ e.jsx(
              ne,
              {
                id: _.id,
                parentId: j,
                design: i.design,
                subModules: b,
                analysisName: i.title,
                typeContainer: $,
                updateDesign: g,
                reloadDesign: w,
                viewMode: me,
                originalEntity: _
              }
            ) : /* @__PURE__ */ e.jsx(
              Qe,
              {
                statusText: "Analysis of this type was not found",
                status: 404,
                message: "",
                data: void 0,
                path: ""
              }
            ) })
          }
        ),
        /* @__PURE__ */ e.jsx(
          B,
          {
            path: "concept-sets/*",
            element: /* @__PURE__ */ e.jsx(
              b.concept,
              {
                type: "component",
                name: "concept-set-sections-widget-new",
                subModules: b,
                config: {
                  onChange: (F) => {
                    g(ae, F);
                  },
                  conceptSets: ((lt = i.design) == null ? void 0 : lt[ae]) || [],
                  viewMode: me,
                  parentId: j,
                  typeContainer: $,
                  analysisMode: !0
                }
              }
            )
          }
        ),
        /* @__PURE__ */ e.jsx(
          B,
          {
            path: "versions",
            element: /* @__PURE__ */ e.jsx(Ye, { children: /* @__PURE__ */ e.jsx(
              gs,
              {
                data: _,
                path: h,
                makeCopy: pe,
                setPreviewEntity: K,
                apiMethods: I,
                originVersionId: _ == null ? void 0 : _.versionId
              }
            ) })
          }
        ),
        /* @__PURE__ */ e.jsx(B, { path: "executions/*", children: /* @__PURE__ */ e.jsxs(
          B,
          {
            path: "*",
            element: /* @__PURE__ */ e.jsx(
              ui,
              {
                path: h,
                analysisId: _.id,
                studyId: j,
                updateRequest: !1,
                rootPath: S,
                type: _.type,
                resultFormater: ue,
                viewMode: me,
                executionCount: r
              }
            ),
            children: [
              /* @__PURE__ */ e.jsx(
                B,
                {
                  path: "execution/:executionId/*",
                  element: /* @__PURE__ */ e.jsx(
                    He,
                    {
                      width: "95%",
                      open: !0,
                      onClose: () => {
                        n("executions");
                      },
                      children: /* @__PURE__ */ e.jsx(yi, {})
                    }
                  )
                }
              ),
              /* @__PURE__ */ e.jsx(
                B,
                {
                  path: "submission/:submissionId/*",
                  element: /* @__PURE__ */ e.jsx(
                    He,
                    {
                      width: "95%",
                      open: !0,
                      onClose: () => {
                        n("executions");
                      },
                      children: /* @__PURE__ */ e.jsx(Bt, {})
                    }
                  )
                }
              )
            ]
          }
        ) })
      ] }) })
    ] }) })
  ] }) });
}, Ce = Xt(null), Ei = (n) => {
  const { path: t, title: s, name: o, rootSettings: l, initStorage: c, viewMode: u } = n, [y, m] = H(l), [r, d] = H(!0), a = Lt((T) => T.user), { analyses: h, status: p } = Nt({
    preloadAnalysisTypes: n.config.analysisTypes,
    analyses: Mt,
    tenantId: a.data.activeTenant
  });
  return W(() => {
    l || m({
      rootPath: t,
      rootTitle: s
    }), d(!1);
  }, []), r || [E.INITIAL, E.IN_PROGRESS].includes(p) ? /* @__PURE__ */ e.jsx(ge, { children: /* @__PURE__ */ e.jsx(G, { size: 32 }) }) : /* @__PURE__ */ e.jsx(
    Ce.Provider,
    {
      value: {
        ...n,
        rootSettings: y,
        analysesTypes: h
      },
      children: /* @__PURE__ */ e.jsxs(Ee, { children: [
        /* @__PURE__ */ e.jsx(
          B,
          {
            path: ":id/*",
            element: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              /* @__PURE__ */ e.jsx(hi, {}),
              /* @__PURE__ */ e.jsx(Ee, { children: /* @__PURE__ */ e.jsx(
                B,
                {
                  path: "submissions/:submissionId/*",
                  element: /* @__PURE__ */ e.jsx(Bt, {})
                }
              ) })
            ] })
          }
        ),
        /* @__PURE__ */ e.jsx(B, { index: !0, element: /* @__PURE__ */ e.jsx(Fa, { viewMode: u }) })
      ] })
    }
  );
}, Ni = (n) => {
  const { type: t } = n;
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    !t && /* @__PURE__ */ e.jsx(Ei, { ...n }),
    t === "component" && /* @__PURE__ */ e.jsx(Ua, { ...n })
  ] });
};
export {
  Ni as Analyses
};
//# sourceMappingURL=analyses.js.map
